export const messages = {
    defaultLocale: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "",
        issueStatuses: "",
        noAvailableStatus: "",
        selectAll: "",
        deselectAll: "",
        close: "",
        itemTypes: "",
        issues: "",
        processes: "",
        statuses: "",
        globalFilters: "",
      },
      //App.vue
      project: "",
      teams: "",
      drawings: "",
      documents: "",
      controllers: "",
      activity: "",
      tasks: "",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "",
        leadTeam: "",
        task: "",
        planned: "",
        actual: "",
        today: "",
        variance: "",
        manDays: "",
        filtered: "",
        noData: "",
        liteChip: "",
        liteTooltip: "",
        tasksUnit: "",
        noProgress: "",
        liteTitle: "",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "",
        syncChip: "",
        liteChip: "",
        live: "",
        overall: "",
        plannedFinish: "",
        daysLeft: "",
        overrun: "",
        currentTasks: "",
        oneBucket: "",
        total: "",
        needingWork: "",
        canMove: "",
        yourTeams: "",
        noTeam: "",
        adminScope: "",
        clearFilters: "",
        noMatch: "",
        completedThisWeek: "",
        vsLastWeek: "",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "",
        open: "",
        upcoming: "",
        upcomingHint: "",
        onSchedule: "",
        onScheduleHint: "",
        behindSchedule: "",
        behindScheduleHint: "",
        overdue: "",
        overdueHint: "",
        overdueUpTo: "",
        delayed: "",
        delayedHint: "",
        completed: "",
        completedHint: "",
        notStarted: "",
        notStartedHint: "",
        inProgress: "",
        inProgressHint: "",
        updatedThisWeek: "",
        stalled: "",
        stalledHint: "",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "",
        doneSuffix: "",
        dueSuffix: "",
        spanDays: "",
        spanWeeks: "",
        weekBtn: "",
        wkPast: "",
        wkNext: "",
        verdictAbove: "",
        verdictBelow: "",
        verdictMatch: "",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "",
        task: "",
        updated: "",
        progress: "",
        dates: "",
        today: "",
        yesterday: "",
        daysAgo: "",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "",
        sub: "",
        subAll: "",
        empty: "",
        noData: "",
        waiting: "",
        due: "",
        done: "",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "",
        taskTitle: "",
        taskViewer: "",
        planViewer: "",
        hierarchyPath: "",
        location: "",
        status: "",
        actualProgress: "",
        plannedProgress: "",
        plannedStart: "",
        actualStart: "",
        plannedEnd: "",
        completion: "",
        overdueDays: "",
        cycleDays: "",
        download: "",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "",
        progressPerWeek: "",
        tasksPerWeek: "",
        toFinish: "",
        weeksShort: "",
        avg: "",
        verdictUp: "",
        verdictDown: "",
        verdictSteady: "",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "",
        noData: "",
        tasks: "",
        noDrawingSet: "",
        expandAll: "",
        collapseAll: "",
      },
      switchTheme: "",
      //ProjectPage.vue
      projectSummary: "",
      //TeamsPage.vue
      overview: "",
      assignment: "",
      //DocumentsPage.vue
      totalDocuments: "",
      totalStorage: "",
      documentsByTeamAndUser: "",
      documentRepository: "",
      latestDocuments: "",
      name: "",
      type: "",
      size: "",
      date: "",
      folder: "",
      uploadedBy: "",
      uploadedDate: "",
      root: "",
      unknownFolder: "",
      unknownTeam: "",
      unknownUser: "",
      //charts
      itemBreakdown: "",
      controllerBreakdown: "",
      documentUploads: "",
      count: "",
      documentTypes: "",
      drawingBreakdown: "",
      activityByItem: "",
      activityByLocation: "",
      burnup: {
        title: "",
        tooltip: "",
        day: "",
        week: "",
        month: ""
      },
      velocityOverTime: "",
      velocityTooltip: "",
      day: "",
      week: "",
      month: "",
      activityByTeam: "",
      teamAndUserBreakdown: "",
      settings: {
        title: "Settings",
        url: "URL",
        username: "Username",
        password: "Password",
        selectProject: "Select Project",
        close: "Close",
        submit: "Submit",
        logout: "Logout"
      },
      welcomeMessage: "",
      loadDashboard: "",
      devModeActivated: "",
      copyQueryStringTitle: "",
      manualCopyInstruction: "",
      copy: "",
      copyFailed: "",
      search: "",
      downloadPDF: "",
      downloadWord: "",
      downloadExcel: "",
      downloadCSV: "",
      A4: "",
      A3: "",
      Excel: "",
      summaryReport: "",
      subcategory: "",
      generateReport:"",
      downloadReport:"",
      reportGenerated: "",
      byCategory: "",
      byDrawingLocation: "",
      byDrawingAssignee: "",
      byController: "",
      grid: '',
      numeric: '',
      selectReportType: '',
      selectFileFormat: '',
      selectPageSize: '',
      id: "",
      item: "",
      assignedTo: "",
      location: "",
      createdBy: "",
      updatedDate: "",
      status: "",
      itemsGrid: "",
      noData: "",
      itemsPerPage: "",
      subItem: "",
      searchTeams: "",
      assign: "",
      tooltips: {
        selectUnassigned: "",
        selectAll: "",
        deselectAll: "",
      },
      headers: {
        subItem: "",
        assignedTo: "",
        updatedDate: "",
        status: "",
      },
      cards: {
        unassigned: "",
        userUnassigned: "",
        draft: "",
        open: "",
        closed: "",
      },
      assignedToYou: "",
      assignedToYourTeams: "",
      controlledByYourTeams: "",
      totalItems: "",
      totalOpenItems:"",
      totalOpenItemsTooltip: "",
      totalSubItems: "",
      totalSubItemsTooltip: "",
      category: "",
      drawingSets: "",
      others: "",
      teamDistribution: "",
      totalCount: "",
      total: "",
      rdriveBurndownChart: "",
      rdriveVelocityChart: "",
      teamProfile: "",
      unAssigned: "",
      createdByYou: "",
      loadingData: "",
      loadingActivity: "",
      noActivityWarning:"",
      cancel: "",
      today: "",
        dayAgo: "",
        daysAgo: ""
    },
    en: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Filter Options",
        issueStatuses: "Issue Statuses",
        noAvailableStatus: "No Available Status",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        close: "Close",
        itemTypes: "Item Types",
        issues: "Issues",
        processes: "Processes",
        statuses: "Statuses",
        globalFilters: "Global Filters",
      },
      //App.vue
      project: "Project",
      teams: "Teams",
      drawings: "Drawings",
      documents: "Documents",
      controllers: "Controllers",
      activity: "Activity",
      tasks: "Tasks",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Progress S-Curve — Planned vs Actual",
        leadTeam: "Lead team",
        task: "Task",
        planned: "Planned",
        actual: "Actual",
        today: "Today",
        variance: "Variance",
        manDays: "man-days",
        filtered: "filtered",
        noData: "No schedule data available",
        liteChip: "PM lite",
        liteTooltip: "This schedule has no planned dates, so there is no planned curve. Each task counts as 1 day of work.",
        tasksUnit: "tasks",
        noProgress: "No progress has been recorded yet",
        liteTitle: "Progress S-Curve — Actual",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Work progress",
        syncChip: "PM Sync · dated schedule",
        liteChip: "PM Lite · no dates",
        live: "Live",
        overall: "Overall",
        plannedFinish: "Planned finish",
        daysLeft: "Days left",
        overrun: "Overrun {n}",
        currentTasks: "Current tasks",
        oneBucket: "Each task sits in one bucket",
        total: "Total",
        needingWork: "tasks needing work today",
        canMove: "tasks that can move today",
        yourTeams: "{teams} · your teams",
        noTeam: "You are not in any team, so no tasks are shown",
        adminScope: "All teams · administrator",
        clearFilters: "Clear filters",
        noMatch: "No tasks match the current selection",
        completedThisWeek: "Completed this week",
        vsLastWeek: "{n} vs last week",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Total tasks",
        open: "{n} open",
        upcoming: "Upcoming",
        upcomingHint: "Start date after today",
        onSchedule: "On schedule",
        onScheduleHint: "Started · progress at or above plan",
        behindSchedule: "Behind schedule",
        behindScheduleHint: "Started · progress below plan",
        overdue: "Overdue",
        overdueHint: "Should have started",
        overdueUpTo: "up to {n} days ago",
        delayed: "Delayed",
        delayedHint: "Overdue + behind schedule",
        completed: "Completed",
        completedHint: "{pct}% of tasks",
        notStarted: "Not started",
        notStartedHint: "No progress recorded",
        inProgress: "In progress",
        inProgressHint: "Progress recorded, not yet complete",
        updatedThisWeek: "Updated this week",
        stalled: "Stalled",
        stalledHint: "No update in 7+ days",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Workload",
        doneSuffix: "done · last {span}",
        dueSuffix: "due · next {span}",
        spanDays: "{n} days",
        spanWeeks: "{n} weeks",
        weekBtn: "{n}w",
        wkPast: "Wk -{n}",
        wkNext: "Wk +{n}",
        verdictAbove: "Due work is {pct}% above the recent completion rate — check capacity",
        verdictBelow: "Due work is below the recent completion rate — capacity to pull work forward",
        verdictMatch: "Due work matches the recent completion rate",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Recent activity",
        task: "Task",
        updated: "Updated",
        progress: "Progress",
        dates: "Dates",
        today: "Today",
        yesterday: "Yesterday",
        daysAgo: "{n} days ago",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Others waiting on us",
        sub: "Our unfinished tasks other teams depend on",
        subAll: "Unfinished tasks that other tasks depend on",
        empty: "No other team is waiting on us.",
        noData: "No prerequisites are recorded on this project's tasks yet.",
        waiting: "{n} waiting",
        due: "due {date}",
        done: "{pct}% done",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Task details",
        taskTitle: "Task title",
        taskViewer: "Task viewer",
        planViewer: "Plan viewer",
        hierarchyPath: "Hierarchy path",
        location: "Location",
        status: "Task status",
        actualProgress: "Actual progress",
        plannedProgress: "Planned progress",
        plannedStart: "Planned start",
        actualStart: "Actual start",
        plannedEnd: "Planned end",
        completion: "Completion",
        overdueDays: "Overdue (days)",
        cycleDays: "Cycle (days)",
        download: "Download CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Pace",
        progressPerWeek: "progress per week",
        tasksPerWeek: "tasks completed per week",
        toFinish: "to finish at this pace",
        weeksShort: "~{n} wks",
        avg: "avg",
        verdictUp: "Pace is up vs the previous {n} weeks",
        verdictDown: "Pace is down vs the previous {n} weeks",
        verdictSteady: "Pace is steady vs the previous {n} weeks",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Progress by drawing set hierarchy",
        noData: "No tasks in scope are linked to a drawing",
        tasks: "{n} tasks",
        noDrawingSet: "No drawing set",
        expandAll: "Expand all",
        collapseAll: "Collapse all",
      },
      switchTheme: "Switch to {theme} Theme",
      //ProjectPage.vue
      projectSummary: 'Project Summary',
      //TeamsPage.vue
      overview: 'Overview',
      assignment: 'Assignment',
      //DocumfentsPage.vue:
      totalDocuments: 'Total Documents',
      totalStorage: 'Total Storage',
      documentsByTeamAndUser: 'Documents by Team and User',
      documentRepository: 'Document Repository',
      latestDocuments: 'Latest Documents',
      name: 'Name',
      type: 'Type',
      size: 'Size',
      date: 'Date',
      folder: 'Folder',
      uploadedBy: 'Uploaded By',
      uploadedDate: 'Uploaded Date',
      root: 'Root',
      unknownFolder: 'Unknown Folder',
      unknownTeam: 'Unknown Team',
      unknownUser: 'Unknown User',
      //charts
      itemBreakdown: "Item Breakdown",
      controllerBreakdown: "Controller Breakdown",
      documentUploads: "Document Uploads Over Time",
      count: "Count",
      documentTypes: "Document Types",
      drawingBreakdown: "Drawing Breakdown",
      activityByItem: "Activity By Item",
      activityByLocation: "Activity By Location",
      burnup: {
        title: "Burnup",
        tooltip: "This chart shows the historic cumulative status over time of your project.",
        day: "Day",
        week: "Week",
        month: "Month"
      },
      velocityOverTime: "Velocity Over Time",
      velocityTooltip: "This chart shows the status change activity for your project",
      day: "Day",
      week: "Week",
      month: "Month",
      activityByTeam: "Activity By Team",
      teamAndUserBreakdown: "Team and User Breakdown",
      settings: {
        title: "Settings",
        url: "URL",
        username: "Username",
        password: "Password",
        selectProject: "Select Project",
        close: "Close",
        submit: "Submit",
        logout: "Logout"
      },
      welcomeMessage: "Welcome to {projectName}",
      loadDashboard: "Load Dashboard",
      devModeActivated: "Dev mode activated",
      copyQueryStringTitle: "Copy Query String",
      manualCopyInstruction: "Select the text above and copy it manually (Ctrl/Cmd+C)",
      copy: "Copy",
      copyFailed: "Failed to copy",
      search: 'Search',
      downloadPDF: 'Download PDF',
      downloadWord: 'Download Word',
      downloadExcel: 'Download Excel',
      downloadCSV: 'Download CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader:"Summary Report",
      summaryReport: "Summary Report",
      subcategory: "Subcategory",
      generateReport:"Generate Report",
      downloadReport:"Download Report",
      reportGenerated: "Report Generated",
      byCategory: "By Category", 
      byDrawingLocation: "By Drawing Location",
      byDrawingAssignee: "By Drawing Assignee",
      byController: "By Controller",
      grid:"Grid",
      numeric:"Numeric",
      selectReportType:"Select Report Type",
      selectFileFormat:"Select File Format",
      selectPageSize:"Select Page Size",
      id: 'ID',
      item: 'Item',
      assignedTo: 'Assigned To',
      location: 'Location',
      createdBy: 'Created By',
      updatedDate: 'Updated Date',
      status: 'Status',
      itemsGrid: 'Items Grid',///////////////
      noData: 'No data available',
      itemsPerPage: 'Items per page',
      subItem: 'Sub-Item',
      searchTeams: "Search teams",
      assign: "Assign ({count})",
      tooltips: {
        selectUnassigned: "Select User Un-Assigned",
        selectAll: "Select All",
        deselectAll: "De-Select All",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Assigned To",
        updatedDate: "Updated Date",
        status: "Status",
      },
      cards: {
        unassigned: "Un-Assigned",
        userUnassigned: "User Un-Assigned",
        draft: "Draft",
        open: "Open",
        closed: "Closed",
      },
      assignedToYou: "Assigned to You",
      assignedToYourTeams: "Assigned to your Team(s)",
      controlledByYourTeams: "Controlled by your Team(s)",
      totalItems: "Total Items",
      totalOpenItems:"Total Open Items",
      totalOpenItemsTooltip:"Total Open Items mode only includes items that are at an open status.",
      totalSubItems: "Total Sub Items",
      totalSubItemsTooltip: "Total Sub Items includes templates with multiple forms.",
      category: "Category",
      drawingSets: "Drawing Sets",
      others: "Others",
      teamDistribution: "Team Distribution",
      totalCount: "Total Count",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Team Profile",
      unAssigned: "Un-Assigned",
      createdByYou: "Created By You",
      createdByYourTeams: "Created by your Team(s)",
      loadingData: "Loading",
      loadingActivity: "Loading Activity",
      noActivityWarning: "There is no activity during the selected date range.",
      cancel: "Cancel",
      today: "Updated Today",
      dayAgo: "Updated {daysSince} Day Ago",
      daysAgo: "Updated {daysSince} Days Ago"
    },
    fr: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Options de Filtre",
        issueStatuses: "Statuts des Problèmes",
        noAvailableStatus: "Aucun Statut Disponible",
        selectAll: "Tout Sélectionner",
        deselectAll: "Tout Désélectionner",
        close: "Fermer",
        itemTypes: "Types d'Éléments",
        issues: "Problèmes",
        processes: "Processus",
        statuses: "Statuts",
        globalFilters: "Filtres globaux",
      },
      //App.vue
      project: "Projet",
      teams: "Équipes",
      drawings: "Dessins",
      documents: "Documents",
      controllers: "Contrôleurs",
      activity: "Activité",
      tasks: "Tâches",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Courbe en S — Prévu vs Réel",
        leadTeam: "Équipe responsable",
        task: "Tâche",
        planned: "Prévu",
        actual: "Réel",
        today: "Aujourd'hui",
        variance: "Écart",
        manDays: "jours-homme",
        filtered: "filtré",
        noData: "Aucune donnée de planning disponible",
        liteChip: "PM lite",
        liteTooltip: "Ce planning n'a pas de dates prévues, il n'y a donc pas de courbe prévue. Chaque tâche compte pour 1 jour de travail.",
        tasksUnit: "tâches",
        noProgress: "Aucune progression enregistrée pour le moment",
        liteTitle: "Courbe en S — Réel",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Avancement des travaux",
        syncChip: "PM Sync · planning daté",
        liteChip: "PM Lite · sans dates",
        live: "En direct",
        overall: "Vue d'ensemble",
        plannedFinish: "Fin prévue",
        daysLeft: "Jours restants",
        overrun: "Dépassement de {n} j",
        currentTasks: "Tâches en cours",
        oneBucket: "Chaque tâche n'apparaît que dans une catégorie",
        total: "Total",
        needingWork: "tâches à traiter aujourd'hui",
        canMove: "tâches pouvant avancer aujourd'hui",
        yourTeams: "{teams} · vos équipes",
        noTeam: "Vous n'êtes dans aucune équipe, aucune tâche n'est donc affichée",
        adminScope: "Toutes les équipes · administrateur",
        clearFilters: "Effacer les filtres",
        noMatch: "Aucune tâche ne correspond à la sélection",
        completedThisWeek: "Terminées cette semaine",
        vsLastWeek: "{n} vs semaine dernière",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Tâches totales",
        open: "{n} ouvertes",
        upcoming: "À venir",
        upcomingHint: "Date de début après aujourd'hui",
        onSchedule: "Dans les temps",
        onScheduleHint: "Démarrée · progression égale ou supérieure au plan",
        behindSchedule: "En retard sur le plan",
        behindScheduleHint: "Démarrée · progression inférieure au plan",
        overdue: "En souffrance",
        overdueHint: "Aurait dû démarrer",
        overdueUpTo: "il y a jusqu'à {n} jours",
        delayed: "Retardées",
        delayedHint: "En souffrance + en retard sur le plan",
        completed: "Terminées",
        completedHint: "{pct}% des tâches",
        notStarted: "Non démarrées",
        notStartedHint: "Aucune progression enregistrée",
        inProgress: "En cours",
        inProgressHint: "Progression enregistrée, pas encore terminée",
        updatedThisWeek: "Mis à jour cette semaine",
        stalled: "Au point mort",
        stalledHint: "Aucune mise à jour depuis 7 jours ou plus",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Charge de travail",
        doneSuffix: "terminées · {span} passés",
        dueSuffix: "à échéance · {span} à venir",
        spanDays: "{n} jours",
        spanWeeks: "{n} semaines",
        weekBtn: "{n}s",
        wkPast: "Sem. -{n}",
        wkNext: "Sem. +{n}",
        verdictAbove: "Le travail à échéance dépasse de {pct} % le rythme récent d'achèvement — vérifier la capacité",
        verdictBelow: "Le travail à échéance est inférieur au rythme récent d'achèvement — capacité pour avancer du travail",
        verdictMatch: "Le travail à échéance correspond au rythme récent d'achèvement",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Activité récente",
        task: "Tâche",
        updated: "Mise à jour",
        progress: "Avancement",
        dates: "Dates",
        today: "Aujourd'hui",
        yesterday: "Hier",
        daysAgo: "il y a {n} jours",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "D'autres équipes nous attendent",
        sub: "Nos tâches inachevées dont dépendent d'autres équipes",
        subAll: "Tâches inachevées dont dépendent d'autres tâches",
        empty: "Aucune autre équipe n'attend après nous.",
        noData: "Aucun prérequis n'est encore enregistré sur les tâches de ce projet.",
        waiting: "{n} en attente",
        due: "échéance {date}",
        done: "{pct} % fait",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Détail des tâches",
        taskTitle: "Titre de la tâche",
        taskViewer: "Visionneuse de tâches",
        planViewer: "Visionneuse de plans",
        hierarchyPath: "Chemin hiérarchique",
        location: "Emplacement",
        status: "Statut",
        actualProgress: "Avancement réel",
        plannedProgress: "Avancement prévu",
        plannedStart: "Début prévu",
        actualStart: "Début réel",
        plannedEnd: "Fin prévue",
        completion: "Achèvement",
        overdueDays: "Retard (jours)",
        cycleDays: "Cycle (jours)",
        download: "Télécharger CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Rythme",
        progressPerWeek: "avancement par semaine",
        tasksPerWeek: "tâches terminées par semaine",
        toFinish: "pour finir à ce rythme",
        weeksShort: "~{n} sem.",
        avg: "moy.",
        verdictUp: "Le rythme est en hausse par rapport aux {n} semaines précédentes",
        verdictDown: "Le rythme est en baisse par rapport aux {n} semaines précédentes",
        verdictSteady: "Le rythme est stable par rapport aux {n} semaines précédentes",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Avancement par hiérarchie de jeux de plans",
        noData: "Aucune tâche du périmètre n'est liée à un plan",
        tasks: "{n} tâches",
        noDrawingSet: "Sans jeu de plans",
        expandAll: "Tout développer",
        collapseAll: "Tout réduire",
      },
      switchTheme: "Passer au thème {theme}",
      //ProjectPage.vue
      projectSummary: 'Résumé du projet',
      //TeamsPage.vue
      overview: 'Aperçu',
      assignment: 'Affectation',
      //DocumentsPage.vue
      totalDocuments: 'Documents Totaux',
      totalStorage: 'Stockage Total',
      documentsByTeamAndUser: 'Documents par Équipe et Utilisateur',
      documentRepository: 'Répertoire de Documents',
      latestDocuments: 'Derniers Documents',
      name: 'Nom',
      type: 'Type',
      size: 'Taille',
      date: 'Date',
      folder: 'Dossier',
      uploadedBy: 'Téléchargé par',
      uploadedDate: 'Date de Téléversement',
      root: 'Racine',
      unknownFolder: 'Dossier Inconnu',
      unknownTeam: 'Équipe Inconnue',
      unknownUser: 'Utilisateur Inconnu',
      //charts
      itemBreakdown: "Répartition des articles",
      controllerBreakdown: "Répartition du contrôleur",
      documentUploads: "Téléchargements de documents au fil du temps",
      count: "Nombre",
      documentTypes: "Types de documents",
      drawingBreakdown: "Répartition des dessins",
      activityByItem: "Activité par article",
      activityByLocation: "Activité par lieu",
      burnup: {
        title: "Diagramme de Burnup",
        tooltip: "Ce graphique montre l'état cumulatif historique de votre projet au fil du temps.",
        day: "Jour",
        week: "Semaine",
        month: "Mois"
      },
      velocityOverTime: "Vélocité au fil du temps",
      velocityTooltip: "Ce graphique montre l'activité de changement de statut pour votre projet",
      day: "Jour",
      week: "Semaine",
      month: "Mois",
      activityByTeam: "Activité par équipe",
      teamAndUserBreakdown: "Répartition par équipe et utilisateur",
      settings: {
        title: "Paramètres",
        url: "URL",
        username: "Nom d'utilisateur",
        password: "Mot de passe",
        selectProject: "Sélectionner le projet",
        close: "Fermer",
        submit: "Soumettre",
        logout: "Déconnexion"
      },
      welcomeMessage: "Bienvenue à {projectName}",
      loadDashboard: "Charger le tableau de bord",
      devModeActivated: "Mode développeur activé",
      copyQueryStringTitle: "Copier la chaîne de requête",
      manualCopyInstruction: "Sélectionnez le texte ci-dessus et copiez-le manuellement (Ctrl/Cmd+C)",
      copy: "Copier",
      copyFailed: "Échec de la copie",
      search: 'Chercher',
      downloadPDF: 'Télécharger PDF',
      downloadWord: 'Télécharger Word',
      downloadExcel: 'Télécharger Excel',
      downloadCSV: 'Télécharger CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Rapport de Synthèse",
      subcategory: "Sous-catégorie",
      reportGenerated: "Rapport généré",
      byCategory: "Par Catégorie",
      byDrawingLocation: "Par Dessin / Emplacement",
      byDrawingAssignee: "Par Dessin / Responsable",
      byController: "Par Contrôleur",
      generateReport: 'Générer le rapport',
      downloadReport: 'Télécharger le rapport',
      grid: 'Grille',
      numeric: 'Numérique',
      selectReportType: 'Sélectionner le type de rapport',
      selectFileFormat: 'Sélectionner le format de fichier',
      selectPageSize: 'Sélectionner la taille de page',
      id: 'ID',
      item: 'Article',
      assignedTo: 'Assigné à',
      location: 'Emplacement',
      createdBy: 'Créé par',
      updatedDate: 'Date de mise à jour',
      status: 'Statut',
      itemsGrid: 'Grille des Articles',
      noData: 'Aucune donnée disponible',
      itemsPerPage: 'Articles par page',
      subItem: 'Sous-Article',
      searchTeams: "Rechercher des équipes",
      assign: "Attribuer ({count})",
      tooltips: {
        selectUnassigned: "Sélectionner l'utilisateur non attribué",
        selectAll: "Tout sélectionner",
        deselectAll: "Tout désélectionner",
      },
      headers: {
        subItem: "Sous-élément",
        assignedTo: "Attribué à",
        updatedDate: "Date de mise à jour",
        status: "Statut",
      },
      cards: {
        unassigned: "Non attribué",
        userUnassigned: "Utilisateur non attribué",
        draft: "Brouillon",
        open: "Ouvert",
        closed: "Fermé",
      },
      assignedToYou: "Attribué à Vous",
      assignedToYourTeams: "Attribué à votre/vos équipe(s)",
      controlledByYourTeams: 'Contrôlé par votre équipe(s)',
      totalItems: 'Articles Totals',
      totalOpenItems: "Total des éléments ouverts",
      totalOpenItemsTooltip: "Le mode Total des éléments ouverts n'inclut que les éléments ayant un statut ouvert.",
      totalSubItems: 'Total des sous-articles',
      totalSubItemsTooltip: 'Le total des sous-articles comprend des modèles avec plusieurs formulaires.',
      category: "Catégorie",
      drawingSets: "Jeux de dessins",
      others: "Autres",
      teamDistribution: "Répartition de l'équipe",
      totalCount: "Nombre total",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart",
      rdriveVelocityChart: "rdrive-velocity-chart",
      teamProfile: "Profil de l'équipe",
      unAssigned: "Non attribué",
      createdByYou: "Created By You",
      createdByYourTeams: "Created by your Team(s)",
      loadingData: "Chargement",
      loadingActivity: "Chargement des activités",
      noActivityWarning: "Aucune activité n'a été enregistrée pendant la période sélectionnée.",
      cancel: "Annuler",
      today: "Mis à jour aujourd'hui",
      dayAgo: "Mis à jour il y a {daysSince} jour",
      daysAgo: "Mis à jour il y a {daysSince} jours"
    },
    it: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Opzioni di Filtro",
        issueStatuses: "Stati dei Problemi",
        noAvailableStatus: "Nessuno Stato Disponibile",
        selectAll: "Seleziona Tutto",
        deselectAll: "Deseleziona Tutto",
        close: "Chiudi",
        itemTypes: "Tipi di Elementi",
        issues: "Problemi",
        processes: "Processi",
        statuses: "Stati",
        globalFilters: "Filtri globali",
      },
      //App.vue
      project: "Progetto",
      teams: "Squadre",
      drawings: "Disegni",
      documents: "Documenti",
      controllers: "Controller",
      activity: "Attività",
      tasks: "Compiti",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Curva a S — Pianificato vs Effettivo",
        leadTeam: "Squadra responsabile",
        task: "Compito",
        planned: "Pianificato",
        actual: "Effettivo",
        today: "Oggi",
        variance: "Scostamento",
        manDays: "giorni-uomo",
        filtered: "filtrato",
        noData: "Nessun dato di programma disponibile",
        liteChip: "PM lite",
        liteTooltip: "Questo programma non ha date pianificate, quindi non c'è una curva pianificata. Ogni compito conta come 1 giorno di lavoro.",
        tasksUnit: "compiti",
        noProgress: "Nessun avanzamento registrato finora",
        liteTitle: "Curva a S — Effettivo",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Avanzamento lavori",
        syncChip: "PM Sync · programma con date",
        liteChip: "PM Lite · senza date",
        live: "In tempo reale",
        overall: "Panoramica",
        plannedFinish: "Fine prevista",
        daysLeft: "Giorni rimanenti",
        overrun: "Sforamento di {n} g",
        currentTasks: "Compiti attuali",
        oneBucket: "Ogni compito rientra in una sola categoria",
        total: "Totale",
        needingWork: "compiti da lavorare oggi",
        canMove: "compiti che possono avanzare oggi",
        yourTeams: "{teams} · i tuoi team",
        noTeam: "Non fai parte di alcun team, quindi non viene mostrato alcun compito",
        adminScope: "Tutti i team · amministratore",
        clearFilters: "Cancella filtri",
        noMatch: "Nessun compito corrisponde alla selezione",
        completedThisWeek: "Completati questa settimana",
        vsLastWeek: "{n} vs settimana scorsa",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Compiti totali",
        open: "{n} aperti",
        upcoming: "In arrivo",
        upcomingHint: "Data di inizio dopo oggi",
        onSchedule: "In linea",
        onScheduleHint: "Avviato · avanzamento pari o superiore al piano",
        behindSchedule: "In ritardo sul piano",
        behindScheduleHint: "Avviato · avanzamento inferiore al piano",
        overdue: "Scaduti",
        overdueHint: "Avrebbe dovuto iniziare",
        overdueUpTo: "fino a {n} giorni fa",
        delayed: "Ritardati",
        delayedHint: "Scaduti + in ritardo sul piano",
        completed: "Completati",
        completedHint: "{pct}% dei compiti",
        notStarted: "Non iniziati",
        notStartedHint: "Nessun avanzamento registrato",
        inProgress: "In corso",
        inProgressHint: "Avanzamento registrato, non ancora completato",
        updatedThisWeek: "Aggiornati questa settimana",
        stalled: "Fermi",
        stalledHint: "Nessun aggiornamento da 7+ giorni",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Carico di lavoro",
        doneSuffix: "completati · ultimi {span}",
        dueSuffix: "in scadenza · prossimi {span}",
        spanDays: "{n} giorni",
        spanWeeks: "{n} settimane",
        weekBtn: "{n}s",
        wkPast: "Sett. -{n}",
        wkNext: "Sett. +{n}",
        verdictAbove: "Il lavoro in scadenza supera del {pct}% il ritmo recente di completamento — verificare la capacità",
        verdictBelow: "Il lavoro in scadenza è inferiore al ritmo recente di completamento — capacità per anticipare lavoro",
        verdictMatch: "Il lavoro in scadenza corrisponde al ritmo recente di completamento",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Attività recente",
        task: "Compito",
        updated: "Aggiornato",
        progress: "Avanzamento",
        dates: "Date",
        today: "Oggi",
        yesterday: "Ieri",
        daysAgo: "{n} giorni fa",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Altri aspettano noi",
        sub: "I nostri compiti incompiuti da cui dipendono altri team",
        subAll: "Compiti incompiuti da cui dipendono altri compiti",
        empty: "Nessun altro team sta aspettando noi.",
        noData: "Nessun prerequisito è ancora registrato sui compiti di questo progetto.",
        waiting: "{n} in attesa",
        due: "scadenza {date}",
        done: "{pct}% fatto",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Dettagli compiti",
        taskTitle: "Titolo compito",
        taskViewer: "Visualizzatore compiti",
        planViewer: "Visualizzatore planimetrie",
        hierarchyPath: "Percorso gerarchico",
        location: "Ubicazione",
        status: "Stato",
        actualProgress: "Avanzamento reale",
        plannedProgress: "Avanzamento previsto",
        plannedStart: "Inizio previsto",
        actualStart: "Inizio effettivo",
        plannedEnd: "Fine prevista",
        completion: "Completamento",
        overdueDays: "Ritardo (giorni)",
        cycleDays: "Ciclo (giorni)",
        download: "Scarica CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Ritmo",
        progressPerWeek: "avanzamento a settimana",
        tasksPerWeek: "compiti completati a settimana",
        toFinish: "per finire a questo ritmo",
        weeksShort: "~{n} sett.",
        avg: "media",
        verdictUp: "Il ritmo è in aumento rispetto alle {n} settimane precedenti",
        verdictDown: "Il ritmo è in calo rispetto alle {n} settimane precedenti",
        verdictSteady: "Il ritmo è stabile rispetto alle {n} settimane precedenti",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Avanzamento per gerarchia dei set di disegni",
        noData: "Nessun compito nell'ambito è collegato a un disegno",
        tasks: "{n} compiti",
        noDrawingSet: "Senza set di disegni",
        expandAll: "Espandi tutto",
        collapseAll: "Comprimi tutto",
      },
      switchTheme: "Passa al tema {theme}",
      //ProjectPage.vue
      projectSummary: 'Riepilogo del progetto',
      //TeamsPage.vue
      overview: 'Panoramica',
      assignment: 'Assegnazione',
      //DocumentsPage.vue
      totalDocuments: 'Documenti Totali',
      totalStorage: 'Archivio Totale',
      documentsByTeamAndUser: 'Documenti per Squadra e Utente',
      documentRepository: 'Archivio Documenti',
      latestDocuments: 'Ultimi Documenti',
      name: 'Nome',
      type: 'Tipo',
      size: 'Dimensione',
      date: 'Data',
      folder: 'Cartella',
      uploadedBy: 'Caricato da',
      uploadedDate: 'Data di Caricamento',
      root: 'Radice',
      unknownFolder: 'Cartella Sconosciuta',
      unknownTeam: 'Squadra Sconosciuta',
      unknownUser: 'Utente Sconosciuto',
      //charts
      itemBreakdown: "Ripartizione Elementi",
      controllerBreakdown: "Ripartizione Controller",
      documentUploads: "Caricamenti Documenti nel Tempo",
      count: "Conteggio",
      documentTypes: "Tipi di Documenti",
      drawingBreakdown: "Ripartizione Disegni",
      activityByItem: "Attività per Elemento",
      activityByLocation: "Attività per Località",
      burnup: {
        title: "Burnup",
        tooltip: "Questo grafico mostra lo stato cumulativo storico del tuo progetto nel tempo.",
        day: "Giorno",
        week: "Settimana",
        month: "Mese"
      },
      velocityOverTime: "Velocità nel Tempo",
      velocityTooltip: "Questo grafico mostra l'attività di cambiamento di stato per il tuo progetto",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      activityByTeam: "Attività per Squadra",
      teamAndUserBreakdown: "Ripartizione per Squadra e Utente",
      settings: {
        title: "Impostazioni",
        url: "URL",
        username: "Nome utente",
        password: "Password",
        selectProject: "Seleziona Progetto",
        close: "Chiudi",
        submit: "Invia",
        logout: "Disconnetti",
      },
      welcomeMessage: "Benvenuto a {projectName}",
      loadDashboard: "Carica Dashboard",
      devModeActivated: "Modalità sviluppatore attivata",
      copyQueryStringTitle: "Copia stringa di query",
      manualCopyInstruction: "Seleziona il testo sopra e copialo manualmente (Ctrl/Cmd+C)",
      copy: "Copia",
      copyFailed: "Copia non riuscita",
      search: 'Cerca',
      downloadPDF: 'Scarica PDF',
      downloadWord: 'Scarica Word',
      downloadExcel: 'Scarica Excel',
      downloadCSV: 'Scarica CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Rapporto Riassuntivo",
      subcategory: "Sottocategoria",
      reportGenerated: "Rapporto generato",
      generateReport: 'Genera rapporto',
      downloadReport: 'Scarica rapporto',
      grid: 'Griglia',
      numeric: 'Numerico',
      selectReportType: 'Seleziona tipo di rapporto',
      selectFileFormat: 'Seleziona formato file',
      selectPageSize: 'Seleziona dimensione pagina',
      byCategory: "Per Categoria",
      byDrawingLocation: "Per Disegno / Posizione",
      byDrawingAssignee: "Per Disegno / Assegnatario",
      byController: "Per Controller",
      id: 'ID',
      item: 'Elemento',
      assignedTo: 'Assegnato a',
      location: 'Posizione',
      createdBy: 'Creato da',
      updatedDate: 'Data di Aggiornamento',
      status: 'Stato',
      itemsGrid: 'Griglia Elementi',
      noData: 'Nessun dato disponibile',
      itemsPerPage: 'Elementi per pagina',
      subItem: 'Sotto-Elemento',
      searchTeams: "Cerca squadre",
      assign: "Assegna ({count})",
      tooltips: {
        selectUnassigned: "Seleziona Utente Non Assegnato",
        selectAll: "Seleziona Tutto",
        deselectAll: "Deseleziona Tutto",
      },
      headers: {
        subItem: "Sotto-Elemento",
        assignedTo: "Assegnato a",
        updatedDate: "Data di Aggiornamento",
        status: "Stato",
      },
      cards: {
        unassigned: "Non Assegnato",
        userUnassigned: "Utente Non Assegnato",
        draft: "Bozza",
        open: "Aperto",
        closed: "Chiuso",
      },
      assignedToYou: "Assegnato a Te",
      assignedToYourTeams: "Assegnato al tuo Team",
      controlledByYourTeams: 'Controllato dal tuo Team',
      totalItems: 'Elementi Totali',
      totalOpenItems: "Totale Elementi Aperti",
      totalOpenItemsTooltip: "La modalità Totale Elementi Aperti include solo gli elementi con stato aperto.",
      totalSubItems: 'Totale Sotto-Elementi',
      totalSubItemsTooltip: 'Il totale dei sotto-elementi include modelli con più moduli.',
      category: "Categoria",
      drawingSets: "Set di disegni",
      others: "Altri",
      teamDistribution: "Distribuzione del team",
      totalCount: "Conteggio totale",
      total: "Totale",
      rdriveBurndownChart: "rdrive-burnup-chart",
      rdriveVelocityChart: "rdrive-velocity-chart",
      teamProfile: "Profilo del team",
      unAssigned: "Non assegnato",
      createdByYou: "Creato da te",
      createdByYourTeams: "Creato dal tuo team/dai tuoi team",
      loadingData: "Caricamento",
      loadingActivity: "Caricamento attività",
      noActivityWarning: "Nessuna attività registrata nell'intervallo di date selezionato.",
      cancel: "Annulla",
      today: "Aggiornato oggi",
      dayAgo: "Aggiornato {daysSince} giorno fa",
      daysAgo: "Aggiornato {daysSince} giorni fa"
    },
    "zh-Hans": {
      //StatusFilterFab.vue
      filterDialog: {
        title: "筛选选项",
        issueStatuses: "问题状态",
        noAvailableStatus: "无可用状态",
        selectAll: "全选",
        deselectAll: "取消全选",
        close: "关闭",
        itemTypes: "项目类型",
        issues: "问题",
        processes: "流程",
        statuses: "状态",
        globalFilters: "全局筛选",
      },
      //App.vue
      project: "项目",
      teams: "团队",
      drawings: "图纸",
      documents: "文件",
      controllers: "控制權",
      activity: "操作记录",
      tasks: "任务",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "进度 S 曲线 — 计划与实际",
        leadTeam: "负责团队",
        task: "任务",
        planned: "计划",
        actual: "实际",
        today: "今天",
        variance: "偏差",
        manDays: "人天",
        filtered: "已筛选",
        noData: "没有可用的进度计划数据",
        liteChip: "PM lite",
        liteTooltip: "此进度计划没有计划日期，因此没有计划曲线。每个任务按 1 个工作日计算。",
        tasksUnit: "个任务",
        noProgress: "尚未记录任何进度",
        liteTitle: "进度 S 曲线 — 实际",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "工作进度",
        syncChip: "PM Sync · 有日期的计划",
        liteChip: "PM Lite · 无日期",
        live: "实时",
        overall: "总体",
        plannedFinish: "计划完成日期",
        daysLeft: "剩余天数",
        overrun: "超期 {n} 天",
        currentTasks: "当前任务",
        oneBucket: "每个任务仅归入一个类别",
        total: "总计",
        needingWork: "今日需处理的任务",
        canMove: "今日可推进的任务",
        yourTeams: "{teams} · 您的团队",
        noTeam: "您不属于任何团队，因此不显示任务",
        adminScope: "所有团队 · 管理员",
        clearFilters: "清除筛选",
        noMatch: "没有任务符合当前选择",
        completedThisWeek: "本周完成",
        vsLastWeek: "较上周 {n}",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "任务总数",
        open: "{n} 个未完成",
        upcoming: "即将开始",
        upcomingHint: "开始日期在今天之后",
        onSchedule: "按计划进行",
        onScheduleHint: "已开始 · 进度达到或超过计划",
        behindSchedule: "落后于计划",
        behindScheduleHint: "已开始 · 进度低于计划",
        overdue: "逾期未开始",
        overdueHint: "本应已开始",
        overdueUpTo: "最多 {n} 天前",
        delayed: "延误",
        delayedHint: "逾期未开始 + 落后于计划",
        completed: "已完成",
        completedHint: "占任务的 {pct}%",
        notStarted: "未开始",
        notStartedHint: "未记录进度",
        inProgress: "进行中",
        inProgressHint: "已记录进度，尚未完成",
        updatedThisWeek: "本周已更新",
        stalled: "停滞",
        stalledHint: "7 天以上未更新",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "工作量",
        doneSuffix: "已完成 · 过去{span}",
        dueSuffix: "到期 · 未来{span}",
        spanDays: "{n} 天",
        spanWeeks: "{n} 周",
        weekBtn: "{n}周",
        wkPast: "第 -{n} 周",
        wkNext: "第 +{n} 周",
        verdictAbove: "到期工作比近期完成速度高出 {pct}% — 请检查产能",
        verdictBelow: "到期工作低于近期完成速度 — 有余力提前推进工作",
        verdictMatch: "到期工作与近期完成速度相当",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "最近活动",
        task: "任务",
        updated: "更新时间",
        progress: "进度",
        dates: "日期",
        today: "今天",
        yesterday: "昨天",
        daysAgo: "{n} 天前",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "其他团队在等我们",
        sub: "其他团队依赖的我们未完成的任务",
        subAll: "其他任务所依赖的未完成任务",
        empty: "没有其他团队在等待我们。",
        noData: "此项目的任务尚未记录任何前置任务。",
        waiting: "{n} 个等待中",
        due: "截止 {date}",
        done: "已完成 {pct}%",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "任务明细",
        taskTitle: "任务标题",
        taskViewer: "任务查看器",
        planViewer: "图纸查看器",
        hierarchyPath: "层级路径",
        location: "位置",
        status: "任务状态",
        actualProgress: "实际进度",
        plannedProgress: "计划进度",
        plannedStart: "计划开始",
        actualStart: "实际开始",
        plannedEnd: "计划结束",
        completion: "完成日期",
        overdueDays: "逾期（天）",
        cycleDays: "周期（天）",
        download: "下载 CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "进度节奏",
        progressPerWeek: "每周进度",
        tasksPerWeek: "每周完成任务数",
        toFinish: "按此节奏完成所需",
        weeksShort: "约 {n} 周",
        avg: "平均",
        verdictUp: "节奏较前 {n} 周加快",
        verdictDown: "节奏较前 {n} 周放缓",
        verdictSteady: "节奏与前 {n} 周持平",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "按图纸集层级的进度",
        noData: "范围内没有任务关联到图纸",
        tasks: "{n} 个任务",
        noDrawingSet: "无图纸集",
        expandAll: "全部展开",
        collapseAll: "全部折叠",
      },
      switchTheme: "切换到 {theme} 主题",
      //ProjectPage.vue
      projectSummary: '项目概况',
      //TeamsPage.vue
      overview: '概览',
      assignment: '分配',
      //DocumentsPage.vue
      totalDocuments: '总文件数',
      totalStorage: '总存储量',
      documentsByTeamAndUser: '按团队和用户的文件',
      documentRepository: '文件库',
      latestDocuments: '最新文件',
      name: '名称',
      type: '类型',
      size: '大小',
      date: '日期',
      folder: '文件夹',
      uploadedBy: '上传者',
      uploadedDate: '上传日期',
      root: '根目录',
      unknownFolder: '未知文件夹',
      unknownTeam: '未知团队',
      unknownUser: '未知用户',
      //charts
      itemBreakdown: "项目明細表",
      controllerBreakdown: "控制權明細表",
      documentUploads: "文件上传随时间变化",
      count: "计数",
      documentTypes: "文件类型",
      drawingBreakdown: "图纸明細表",
      activityByItem: "按项目操作记录",
      activityByLocation: "按位置操作记录",
      burnup: {
        title: "燃尽图",
        tooltip: "该图显示了项目随时间的历史累计状态。",
        day: "天",
        week: "周",
        month: "月"
      },
      velocityOverTime: "随时间变化的速度",
      velocityTooltip: "该图显示了项目的状态变化操作记录",
      day: "天",
      week: "周",
      month: "月",
      activityByTeam: "按团队操作记录",
      teamAndUserBreakdown: "按团队和用户明細表",
      settings: {
        title: "设置",
        url: "URL",
        username: "用户名",
        password: "密码",
        selectProject: "选择项目",
        close: "关闭",
        submit: "提交",
        logout: "登出"
      },
      welcomeMessage: "欢迎来到 {projectName}",
      loadDashboard: "加载仪表板",
      devModeActivated: "开发模式已激活",
      copyQueryStringTitle: "复制查询字符串",
      manualCopyInstruction: "选择上方文本并手动复制 (Ctrl/Cmd+C)",
      copy: "复制",
      copyFailed: "复制失败",
      search: '搜索',
      downloadPDF: '下载 PDF',
      downloadWord: '下载 Word',
      downloadExcel: '下载 Excel',
      downloadCSV: '下载 CSV',
      A4: "A4纸",
      A3: "A3纸",
      Excel: "Excel表格",
      summaryReport: "总结报告",
      subcategory: "子类别",
      reportGenerated: "报告已生成",
      generateReport: '生成报告',
      downloadReport: '下载报告',
      grid: '网格',
      numeric: '数字',
      selectReportType: '选择报告类型',
      selectFileFormat: '选择文件格式',
      selectPageSize: '选择页面大小',
      byCategory: "按类别",
      byDrawingLocation: "按图纸/位置",
      byDrawingAssignee: "按图纸/负责人",
      byController: "按控制權",
      id: 'ID',
      item: '项目',
      assignedTo: '分配给',
      location: '位置',
      createdBy: '创建者',
      updatedDate: '更新日期',
      status: '状态',
      itemsGrid: '项目摘要',
      noData: '无可用数据',
      itemsPerPage: '每页项目数',
      subItem: '子项目',
      searchTeams: "搜索团队",
      assign: "分配 ({count})",
      tooltips: {
        selectUnassigned: "选择未分配用户",
        selectAll: "全选",
        deselectAll: "取消全选",
      },
      headers: {
        subItem: "子项目",
        assignedTo: "分配给",
        updatedDate: "更新日期",
        status: "状态",
      },
      cards: {
        unassigned: "未分配",
        userUnassigned: "用户未分配",
        draft: "草稿",
        open: "开启",
        closed: "关闭",
      },
      assignedToYou: "分配给你",
      assignedToYourTeams: "分配给你的团队",
      controlledByYourTeams: '由你的团队控制',
      totalItems: '总项目数',
      totalOpenItems: "未完成项目总数",
      totalOpenItemsTooltip: "未完成项目总数模式仅包含状态为开放的项目。",
      totalSubItems: '总子项目数',
      totalSubItemsTooltip: '总子项目数包括多个表格的模板。',
      category: "类别",
      drawingSets: "图纸集",
      others: "其他",
      teamDistribution: "团队分配",
      totalCount: "总数",
      total: "总计",
      rdriveBurndownChart: "rdrive-燃尽图",
      rdriveVelocityChart: "rdrive-速度图",
      teamProfile: "团队简介",
      unAssigned: "未分配",
      createdByYou: "由您创建",
      createdByYourTeams: "由您的团队创建",
      loadingData: "加载中",
      loadingActivity: "加载活动数据",
      noActivityWarning: "在所选日期范围内没有任何活动。",
      cancel: "取消",
      today: "今天更新",
      dayAgo: "{daysSince} 天前更新",
      daysAgo: "{daysSince} 天前更新"

    },
    "zh-Hant": {
      //StatusFilterFab.vue
      filterDialog: {
        title: "篩選選項",
        issueStatuses: "事項狀態",
        noAvailableStatus: "無可用狀態",
        selectAll: "全選",
        deselectAll: "取消全選",
        close: "關閉",
        itemTypes: "項目類型",
        issues: "問題",
        processes: "流程",
        statuses: "狀態",
        globalFilters: "全域篩選",
      },
      //App.vue
      project: "項目",
      teams: "團隊",
      drawings: "圖紙",
      documents: "文件",
      controllers: "控制權",
      activity: "操作紀錄",
      tasks: "任務",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "進度 S 曲線 — 計劃與實際",
        leadTeam: "負責團隊",
        task: "任務",
        planned: "計劃",
        actual: "實際",
        today: "今天",
        variance: "偏差",
        manDays: "人天",
        filtered: "已篩選",
        noData: "沒有可用的進度計劃資料",
        liteChip: "PM lite",
        liteTooltip: "此進度計劃沒有計劃日期，因此沒有計劃曲線。每個任務按 1 個工作日計算。",
        tasksUnit: "個任務",
        noProgress: "尚未記錄任何進度",
        liteTitle: "進度 S 曲線 — 實際",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "工作進度",
        syncChip: "PM Sync · 有日期的排程",
        liteChip: "PM Lite · 無日期",
        live: "即時",
        overall: "總體",
        plannedFinish: "計畫完成日期",
        daysLeft: "剩餘天數",
        overrun: "超期 {n} 天",
        currentTasks: "目前任務",
        oneBucket: "每個任務僅歸入一個類別",
        total: "總計",
        needingWork: "今日需處理的任務",
        canMove: "今日可推進的任務",
        yourTeams: "{teams} · 您的團隊",
        noTeam: "您不屬於任何團隊，因此不顯示任務",
        adminScope: "所有團隊 · 管理員",
        clearFilters: "清除篩選",
        noMatch: "沒有任務符合目前選擇",
        completedThisWeek: "本週完成",
        vsLastWeek: "較上週 {n}",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "任務總數",
        open: "{n} 個未完成",
        upcoming: "即將開始",
        upcomingHint: "開始日期在今天之後",
        onSchedule: "按計劃進行",
        onScheduleHint: "已開始 · 進度達到或超過計劃",
        behindSchedule: "落後於計劃",
        behindScheduleHint: "已開始 · 進度低於計劃",
        overdue: "逾期未開始",
        overdueHint: "本應已開始",
        overdueUpTo: "最多 {n} 天前",
        delayed: "延誤",
        delayedHint: "逾期未開始 + 落後於計劃",
        completed: "已完成",
        completedHint: "佔任務的 {pct}%",
        notStarted: "未開始",
        notStartedHint: "未記錄進度",
        inProgress: "進行中",
        inProgressHint: "已記錄進度，尚未完成",
        updatedThisWeek: "本週已更新",
        stalled: "停滯",
        stalledHint: "7 天以上未更新",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "工作量",
        doneSuffix: "已完成 · 過去{span}",
        dueSuffix: "到期 · 未來{span}",
        spanDays: "{n} 天",
        spanWeeks: "{n} 週",
        weekBtn: "{n}週",
        wkPast: "第 -{n} 週",
        wkNext: "第 +{n} 週",
        verdictAbove: "到期工作比近期完成速度高出 {pct}% — 請檢查產能",
        verdictBelow: "到期工作低於近期完成速度 — 有餘力提前推進工作",
        verdictMatch: "到期工作與近期完成速度相當",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "最近活動",
        task: "任務",
        updated: "更新時間",
        progress: "進度",
        dates: "日期",
        today: "今天",
        yesterday: "昨天",
        daysAgo: "{n} 天前",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "其他團隊在等我們",
        sub: "其他團隊依賴的我們未完成的任務",
        subAll: "其他任務所依賴的未完成任務",
        empty: "沒有其他團隊在等待我們。",
        noData: "此專案的任務尚未記錄任何前置任務。",
        waiting: "{n} 個等待中",
        due: "截止 {date}",
        done: "已完成 {pct}%",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "任務明細",
        taskTitle: "任務標題",
        taskViewer: "任務檢視器",
        planViewer: "圖紙檢視器",
        hierarchyPath: "階層路徑",
        location: "位置",
        status: "任務狀態",
        actualProgress: "實際進度",
        plannedProgress: "計畫進度",
        plannedStart: "計畫開始",
        actualStart: "實際開始",
        plannedEnd: "計畫結束",
        completion: "完成日期",
        overdueDays: "逾期（天）",
        cycleDays: "週期（天）",
        download: "下載 CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "進度節奏",
        progressPerWeek: "每週進度",
        tasksPerWeek: "每週完成任務數",
        toFinish: "按此節奏完成所需",
        weeksShort: "約 {n} 週",
        avg: "平均",
        verdictUp: "節奏較前 {n} 週加快",
        verdictDown: "節奏較前 {n} 週放緩",
        verdictSteady: "節奏與前 {n} 週持平",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "按圖紙集階層的進度",
        noData: "範圍內沒有任務關聯到圖紙",
        tasks: "{n} 個任務",
        noDrawingSet: "無圖紙集",
        expandAll: "全部展開",
        collapseAll: "全部摺疊",
      },
      switchTheme: "切換到 {theme} 主題",
      //ProjectPage.vue
      projectSummary: '項目概況',
      //TeamsPage.vue
      overview: '概覽',
      assignment: '分配',
      //DocumentsPage.vue
      totalDocuments: '總文件數',
      totalStorage: '總存儲量',
      documentsByTeamAndUser: '按團隊和用戶的文件',
      documentRepository: '文件庫',
      latestDocuments: '最新文件',
      name: '名稱',
      type: '類型',
      size: '大小',
      date: '日期',
      folder: '文件夾',
      uploadedBy: '上傳者',
      uploadedDate: '上傳日期',
      root: '根目錄',
      unknownFolder: '未知文件夾',
      unknownTeam: '未知團隊',
      unknownUser: '未知用戶',
      //charts
      itemBreakdown: "項目明細表",
      controllerBreakdown: "控制權明細表",
      documentUploads: "文件上傳隨時間變化",
      count: "計數",
      documentTypes: "文件類型",
      drawingBreakdown: "圖紙明細表",
      activityByItem: "按項目操作紀錄",
      activityByLocation: "按位置操作紀錄",
      burnup: {
        title: "燃盡圖",
        tooltip: "該圖顯示了項目隨時間的歷史累計狀態。",
        day: "天",
        week: "週",
        month: "月"
      },
      velocityOverTime: "隨時間變化的速度",
      velocityTooltip: "該圖顯示了項目的狀態變化操作紀錄",
      day: "天",
      week: "週",
      month: "月",
      activityByTeam: "按團隊操作紀錄",
      teamAndUserBreakdown: "按團隊和用戶明細表",
      settings: {
        title: "設置",
        url: "URL",
        username: "用戶名",
        password: "密碼",
        selectProject: "選擇項目",
        close: "關閉",
        submit: "提交",
        logout: "登出"
      },
      welcomeMessage: "歡迎來到 {projectName}",
      loadDashboard: "加載儀表板",
      devModeActivated: "開發模式已啟動",
      copyQueryStringTitle: "複製查詢字串",
      manualCopyInstruction: "選擇上方文字並手動複製 (Ctrl/Cmd+C)",
      copy: "複製",
      copyFailed: "複製失敗",
      search: '搜索',
      downloadPDF: '下載 PDF',
      downloadWord: '下載 Word',
      downloadExcel: '下載 Excel',
      downloadCSV: '下載 CSV',
      A4: "A4紙",
      A3: "A3紙",
      Excel: "Excel表格",
      summaryReport: "總結報告",
      subcategory: "子類別",
      reportGenerated: "報告已生成",
      byCategory: "按類別",
      byDrawingLocation: "按圖紙/位置",
      byDrawingAssignee: "按圖紙/負責人",
      byController: "按控制權",
      generateReport: '生成報告',
      downloadReport: '下載報告',
      grid: '網格',
      numeric: '數字',
      selectReportType: '選擇報告類型',
      selectFileFormat: '選擇檔案格式',
      selectPageSize: '選擇頁面大小',
      id: 'ID',
      item: '項目',
      assignedTo: '分配給',
      location: '位置',
      createdBy: '創建者',
      updatedDate: '更新日期',
      status: '狀態',
      itemsGrid: '項目摘要',
      noData: '無可用數據',
      itemsPerPage: '每頁項目數',
      subItem: '子項目',
      searchTeams: "搜索團隊",
      assign: "分配 ({count})",
      tooltips: {
        selectUnassigned: "選擇未分配用戶",
        selectAll: "全選",
        deselectAll: "取消全選",
      },
      headers: {
        subItem: "子項目",
        assignedTo: "分配給",
        updatedDate: "更新日期",
        status: "狀態",
      },
      cards: {
        unassigned: "未分配",
        userUnassigned: "用戶未分配",
        draft: "草稿",
        open: "開啟",
        closed: "關閉",
      },
      assignedToYou: "分配給你",
      assignedToYourTeams: "分配給你的團隊",
      controlledByYourTeams: '由你的團隊控制',
      totalItems: '總項目數',
      totalOpenItems: "未完成項目總數",
      totalOpenItemsTooltip: "未完成項目總數模式僅包含狀態為開放的項目。",
      totalSubItems: '總子項目數',
      totalSubItemsTooltip: '總子項目數包括多個表格的模板。',
      category: "類別",
      drawingSets: "圖紙集",
      others: "其他",
      teamDistribution: "團隊分配",
      totalCount: "總數",
      total: "總計",
      rdriveBurndownChart: "rdrive-燃盡圖",
      rdriveVelocityChart: "rdrive-速度圖",
      teamProfile: "團隊簡介",
      unAssigned: "未分配",
      createdByYou: "由您建立",
      createdByYourTeams: "由您的團隊建立",
      loadingData: "載入中",
      loadingActivity: "載入活動數據",
      noActivityWarning: "在所選日期範圍內沒有任何活動。",
      cancel: "取消",
      today: "今天更新",
      dayAgo: "{daysSince} 天前更新",
      daysAgo: "{daysSince} 天前更新"
    },
    nl: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Filteropties",
        issueStatuses: "Probleemstatussen",
        noAvailableStatus: "Geen Beschikbare Status",
        selectAll: "Alles Selecteren",
        deselectAll: "Alles Deselecteren",
        close: "Sluiten",
        itemTypes: "Itemtypes",
        issues: "Problemen",
        processes: "Processen",
        statuses: "Statussen",
        globalFilters: "Globale filters",
      },
      //App.vue
      project: "Project",
      teams: "Teams",
      drawings: "Tekeningen",
      documents: "Documenten",
      controllers: "Controllers",
      activity: "Activiteit",
      tasks: "Taken",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Voortgang S-curve — Gepland vs Werkelijk",
        leadTeam: "Leidend team",
        task: "Taak",
        planned: "Gepland",
        actual: "Werkelijk",
        today: "Vandaag",
        variance: "Afwijking",
        manDays: "mandagen",
        filtered: "gefilterd",
        noData: "Geen planningsgegevens beschikbaar",
        liteChip: "PM lite",
        liteTooltip: "Deze planning heeft geen geplande datums, dus er is geen geplande curve. Elke taak telt als 1 werkdag.",
        tasksUnit: "taken",
        noProgress: "Er is nog geen voortgang geregistreerd",
        liteTitle: "Voortgang S-curve — Werkelijk",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Werkvoortgang",
        syncChip: "PM Sync · planning met datums",
        liteChip: "PM Lite · geen datums",
        live: "Live",
        overall: "Totaalbeeld",
        plannedFinish: "Geplande einddatum",
        daysLeft: "Dagen resterend",
        overrun: "Overschrijding {n} d",
        currentTasks: "Huidige taken",
        oneBucket: "Elke taak valt in precies één categorie",
        total: "Totaal",
        needingWork: "taken die vandaag werk nodig hebben",
        canMove: "taken die vandaag vooruit kunnen",
        yourTeams: "{teams} · uw teams",
        noTeam: "U zit in geen enkel team, dus er worden geen taken getoond",
        adminScope: "Alle teams · beheerder",
        clearFilters: "Filters wissen",
        noMatch: "Geen taken komen overeen met de selectie",
        completedThisWeek: "Deze week afgerond",
        vsLastWeek: "{n} t.o.v. vorige week",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Totaal taken",
        open: "{n} open",
        upcoming: "Aankomend",
        upcomingHint: "Startdatum na vandaag",
        onSchedule: "Op schema",
        onScheduleHint: "Gestart · voortgang op of boven plan",
        behindSchedule: "Achter op schema",
        behindScheduleHint: "Gestart · voortgang onder plan",
        overdue: "Te laat gestart",
        overdueHint: "Had moeten starten",
        overdueUpTo: "tot {n} dagen geleden",
        delayed: "Vertraagd",
        delayedHint: "Te laat gestart + achter op schema",
        completed: "Afgerond",
        completedHint: "{pct}% van de taken",
        notStarted: "Niet gestart",
        notStartedHint: "Geen voortgang geregistreerd",
        inProgress: "In uitvoering",
        inProgressHint: "Voortgang geregistreerd, nog niet afgerond",
        updatedThisWeek: "Deze week bijgewerkt",
        stalled: "Stilgevallen",
        stalledHint: "Geen update in 7+ dagen",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Werklast",
        doneSuffix: "afgerond · afgelopen {span}",
        dueSuffix: "verwacht · komende {span}",
        spanDays: "{n} dagen",
        spanWeeks: "{n} weken",
        weekBtn: "{n}w",
        wkPast: "Wk -{n}",
        wkNext: "Wk +{n}",
        verdictAbove: "Het verwachte werk ligt {pct}% boven het recente afrondingstempo — controleer de capaciteit",
        verdictBelow: "Het verwachte werk ligt onder het recente afrondingstempo — ruimte om werk naar voren te halen",
        verdictMatch: "Het verwachte werk komt overeen met het recente afrondingstempo",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Recente activiteit",
        task: "Taak",
        updated: "Bijgewerkt",
        progress: "Voortgang",
        dates: "Datums",
        today: "Vandaag",
        yesterday: "Gisteren",
        daysAgo: "{n} dagen geleden",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Anderen wachten op ons",
        sub: "Onze onvoltooide taken waar andere teams van afhangen",
        subAll: "Onvoltooide taken waar andere taken van afhangen",
        empty: "Geen ander team wacht op ons.",
        noData: "Er zijn nog geen voorwaarden vastgelegd op de taken van dit project.",
        waiting: "{n} wachtend",
        due: "deadline {date}",
        done: "{pct}% gedaan",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Taakdetails",
        taskTitle: "Taaktitel",
        taskViewer: "Taakviewer",
        planViewer: "Planviewer",
        hierarchyPath: "Hiërarchiepad",
        location: "Locatie",
        status: "Taakstatus",
        actualProgress: "Werkelijke voortgang",
        plannedProgress: "Geplande voortgang",
        plannedStart: "Geplande start",
        actualStart: "Werkelijke start",
        plannedEnd: "Gepland einde",
        completion: "Afronding",
        overdueDays: "Te laat (dagen)",
        cycleDays: "Doorlooptijd (dagen)",
        download: "CSV downloaden",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Tempo",
        progressPerWeek: "voortgang per week",
        tasksPerWeek: "afgeronde taken per week",
        toFinish: "tot afronding in dit tempo",
        weeksShort: "~{n} wkn",
        avg: "gem.",
        verdictUp: "Het tempo ligt hoger dan in de vorige {n} weken",
        verdictDown: "Het tempo ligt lager dan in de vorige {n} weken",
        verdictSteady: "Het tempo is gelijk aan de vorige {n} weken",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Voortgang per tekeningensethiërarchie",
        noData: "Geen taken in scope zijn aan een tekening gekoppeld",
        tasks: "{n} taken",
        noDrawingSet: "Geen tekeningenset",
        expandAll: "Alles uitklappen",
        collapseAll: "Alles inklappen",
      },
      switchTheme: "Schakel over naar {theme} Thema",
      //ProjectPage.vue
      projectSummary: 'Projectoverzicht',
      //TeamsPage.vue
      overview: 'Overzicht',
      assignment: 'Toewijzing',
      //DocumentsPage.vue
      totalDocuments: 'Totale Documenten',
      totalStorage: 'Totale Opslag',
      documentsByTeamAndUser: 'Documenten per Team en Gebruiker',
      documentRepository: 'Documentenarchief',
      latestDocuments: 'Laatste Documenten',
      name: 'Naam',
      type: 'Type',
      size: 'Grootte',
      date: 'Datum',
      folder: 'Map',
      uploadedBy: 'Geüpload door',
      uploadedDate: 'Uploaddatum',
      root: 'Root',
      unknownFolder: 'Onbekende Map',
      unknownTeam: 'Onbekend Team',
      unknownUser: 'Onbekende Gebruiker',
      //charts
      itemBreakdown: "Item Uitsplitsing",
      controllerBreakdown: "Controller Uitsplitsing",
      documentUploads: "Document Uploads Over Tijd",
      count: "Aantal",
      documentTypes: "Documenttypes",
      drawingBreakdown: "Tekeningen Uitsplitsing",
      activityByItem: "Activiteit Per Item",
      activityByLocation: "Activiteit Per Locatie",
      burnup: {
        title: "Burnup",
        tooltip: "Deze grafiek toont de historische cumulatieve status van je project in de tijd.",
        day: "Dag",
        week: "Week",
        month: "Maand"
      },
      velocityOverTime: "Snelheid Over Tijd",
      velocityTooltip: "Deze grafiek toont de status wijzigingsactiviteit voor je project",
      day: "Dag",
      week: "Week",
      month: "Maand",
      activityByTeam: "Activiteit Per Team",
      teamAndUserBreakdown: "Team- en Gebruikersuitsplitsing",
      settings: {
        title: "Instellingen",
        url: "URL",
        username: "Gebruikersnaam",
        password: "Wachtwoord",
        selectProject: "Selecteer Project",
        close: "Sluiten",
        submit: "Indienen",
        logout: "Uitloggen"
      },
      welcomeMessage: "Welkom bij {projectName}",
      loadDashboard: "Dashboard Laden",
      devModeActivated: "Ontwikkelaarsmodus geactiveerd",
      copyQueryStringTitle: "Querystring kopiëren",
      manualCopyInstruction: "Selecteer de tekst hierboven en kopieer deze handmatig (Ctrl/Cmd+C)",
      copy: "Kopiëren",
      copyFailed: "Kopiëren mislukt",
      search: 'Zoeken',
      downloadPDF: 'Download PDF',
      downloadWord: 'Download Word',
      downloadExcel: 'Download Excel',
      downloadCSV: 'Download CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Samenvattend Rapport",
      subcategory: "Subcategorie",
      reportGenerated: "Rapport gegenereerd",
      byCategory: "Per Categorie",
      byDrawingLocation: "Per Tekening / Locatie",
      byDrawingAssignee: "Per Tekening / Toegewezen Persoon",
      byController: "Per Controller",
      generateReport: 'Rapport genereren',
      downloadReport: 'Rapport downloaden',
      grid: 'Raster',
      numeric: 'Numeriek',
      selectReportType: 'Selecteer rapporttype',
      selectFileFormat: 'Selecteer bestandsformaat',
      selectPageSize: 'Selecteer paginagrootte',
      id: 'ID',
      item: 'Item',
      assignedTo: 'Toegewezen aan',
      location: 'Locatie',
      createdBy: 'Gemaakt door',
      updatedDate: 'Bijgewerkte Datum',
      status: 'Status',
      itemsGrid: 'Item Raster',
      noData: 'Geen gegevens beschikbaar',
      itemsPerPage: 'Items per pagina',
      subItem: 'Sub-Item',
      searchTeams: "Zoek teams",
      assign: "Toewijzen ({count})",
      tooltips: {
        selectUnassigned: "Selecteer Niet-Toegewezen Gebruiker",
        selectAll: "Alles selecteren",
        deselectAll: "Alles deselecteren",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Toegewezen aan",
        updatedDate: "Bijgewerkte Datum",
        status: "Status",
      },
      cards: {
        unassigned: "Niet Toegewezen",
        userUnassigned: "Gebruiker Niet Toegewezen",
        draft: "Concept",
        open: "Open",
        closed: "Gesloten",
      },
      assignedToYou: "Toegewezen aan Jou",
      assignedToYourTeams: "Toegewezen aan jouw Team(s)",
      controlledByYourTeams: 'Gecontroleerd door jouw Team(s)',
      totalItems: 'Totale Items',
      totalSubItems: 'Totale Sub-Items',
      totalSubItemsTooltip: 'Totale Sub-Items omvat sjablonen met meerdere formulieren.',
      totalOpenItems: "Totaal openstaande items",
      totalOpenItemsTooltip: "De modus Totaal openstaande items bevat alleen items met een open status.",
      category: "Categorie",
      drawingSets: "Tekeningen Sets",
      others: "Anderen",
      teamDistribution: "Teamverdeling",
      totalCount: "Totaal aantal",
      total: "Totaal",
      rdriveBurndownChart: "rdrive-afloopgrafiek",
      rdriveVelocityChart: "rdrive-snelheidsgrafiek",
      teamProfile: "Teamprofiel",
      unAssigned: "Niet toegewezen",
      createdByYou: "Door u gemaakt",
      createdByYourTeams: "Gemaakt door uw team(s)",
      loadingData: "Laden",
      loadingActivity: "Activiteit laden",
      noActivityWarning: "Er is geen activiteit gedurende de geselecteerde periode.",
      cancel: "Annuleren",
      today: "Vandaag bijgewerkt",
      dayAgo: "Bijgewerkt {daysSince} dag geleden",
      daysAgo: "Bijgewerkt {daysSince} dagen geleden"
    },
    "pt-BR": {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Opções de Filtro",
        issueStatuses: "Status dos Problemas",
        noAvailableStatus: "Nenhum Status Disponível",
        selectAll: "Selecionar Todos",
        deselectAll: "Desmarcar Todos",
        close: "Fechar",
        itemTypes: "Tipos de Itens",
        issues: "Problemas",
        processes: "Processos",
        statuses: "Status",
        globalFilters: "Filtros globais",
      },
      //App.vue
      project: "Projeto",
      teams: "Equipes",
      drawings: "Desenhos",
      documents: "Documentos",
      controllers: "Controladores",
      activity: "Atividade",
      tasks: "Tarefas",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Curva S de Progresso — Planejado vs Real",
        leadTeam: "Equipe responsável",
        task: "Tarefa",
        planned: "Planejado",
        actual: "Real",
        today: "Hoje",
        variance: "Variação",
        manDays: "dias-homem",
        filtered: "filtrado",
        noData: "Nenhum dado de cronograma disponível",
        liteChip: "PM lite",
        liteTooltip: "Este cronograma não tem datas planejadas, portanto não há curva planejada. Cada tarefa conta como 1 dia de trabalho.",
        tasksUnit: "tarefas",
        noProgress: "Nenhum progresso registrado ainda",
        liteTitle: "Curva S de Progresso — Real",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Progresso do trabalho",
        syncChip: "PM Sync · cronograma com datas",
        liteChip: "PM Lite · sem datas",
        live: "Em tempo real",
        overall: "Visão geral",
        plannedFinish: "Término previsto",
        daysLeft: "Dias restantes",
        overrun: "Atraso de {n} d",
        currentTasks: "Tarefas atuais",
        oneBucket: "Cada tarefa está em apenas uma categoria",
        total: "Total",
        needingWork: "tarefas que precisam de trabalho hoje",
        canMove: "tarefas que podem avançar hoje",
        yourTeams: "{teams} · suas equipes",
        noTeam: "Você não está em nenhuma equipe, então nenhuma tarefa é exibida",
        adminScope: "Todas as equipes · administrador",
        clearFilters: "Limpar filtros",
        noMatch: "Nenhuma tarefa corresponde à seleção atual",
        completedThisWeek: "Concluídas esta semana",
        vsLastWeek: "{n} vs semana passada",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Total de tarefas",
        open: "{n} abertas",
        upcoming: "Próximas",
        upcomingHint: "Data de início após hoje",
        onSchedule: "No prazo",
        onScheduleHint: "Iniciada · progresso igual ou acima do plano",
        behindSchedule: "Atrás do plano",
        behindScheduleHint: "Iniciada · progresso abaixo do plano",
        overdue: "Atrasadas para iniciar",
        overdueHint: "Deveria ter iniciado",
        overdueUpTo: "até {n} dias atrás",
        delayed: "Atrasadas",
        delayedHint: "Atrasadas para iniciar + atrás do plano",
        completed: "Concluídas",
        completedHint: "{pct}% das tarefas",
        notStarted: "Não iniciadas",
        notStartedHint: "Nenhum progresso registrado",
        inProgress: "Em andamento",
        inProgressHint: "Progresso registrado, ainda não concluída",
        updatedThisWeek: "Atualizadas esta semana",
        stalled: "Paradas",
        stalledHint: "Sem atualização há 7+ dias",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Carga de trabalho",
        doneSuffix: "concluídas · últimas {span}",
        dueSuffix: "com prazo · próximas {span}",
        spanDays: "{n} dias",
        spanWeeks: "{n} semanas",
        weekBtn: "{n}s",
        wkPast: "Sem. -{n}",
        wkNext: "Sem. +{n}",
        verdictAbove: "O trabalho com prazo está {pct}% acima do ritmo recente de conclusão — verifique a capacidade",
        verdictBelow: "O trabalho com prazo está abaixo do ritmo recente de conclusão — há capacidade para adiantar trabalho",
        verdictMatch: "O trabalho com prazo corresponde ao ritmo recente de conclusão",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Atividade recente",
        task: "Tarefa",
        updated: "Atualizado",
        progress: "Progresso",
        dates: "Datas",
        today: "Hoje",
        yesterday: "Ontem",
        daysAgo: "há {n} dias",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Outros esperam por nós",
        sub: "Nossas tarefas inacabadas das quais outras equipes dependem",
        subAll: "Tarefas inacabadas das quais outras tarefas dependem",
        empty: "Nenhuma outra equipe está esperando por nós.",
        noData: "Ainda não há pré-requisitos registrados nas tarefas deste projeto.",
        waiting: "{n} aguardando",
        due: "prazo {date}",
        done: "{pct}% concluído",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Detalhes das tarefas",
        taskTitle: "Título da tarefa",
        taskViewer: "Visualizador de tarefas",
        planViewer: "Visualizador de plantas",
        hierarchyPath: "Caminho hierárquico",
        location: "Localização",
        status: "Status",
        actualProgress: "Progresso real",
        plannedProgress: "Progresso planejado",
        plannedStart: "Início planejado",
        actualStart: "Início real",
        plannedEnd: "Término planejado",
        completion: "Conclusão",
        overdueDays: "Atraso (dias)",
        cycleDays: "Ciclo (dias)",
        download: "Baixar CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Ritmo",
        progressPerWeek: "progresso por semana",
        tasksPerWeek: "tarefas concluídas por semana",
        toFinish: "para terminar neste ritmo",
        weeksShort: "~{n} sem.",
        avg: "média",
        verdictUp: "O ritmo está acima das {n} semanas anteriores",
        verdictDown: "O ritmo está abaixo das {n} semanas anteriores",
        verdictSteady: "O ritmo está estável em relação às {n} semanas anteriores",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Progresso por hierarquia de conjuntos de desenhos",
        noData: "Nenhuma tarefa no escopo está vinculada a um desenho",
        tasks: "{n} tarefas",
        noDrawingSet: "Sem conjunto de desenhos",
        expandAll: "Expandir tudo",
        collapseAll: "Recolher tudo",
      },
      switchTheme: "Mudar para Tema {theme}",
      //ProjectPage.vue
      projectSummary: 'Resumo do Projeto',
      //TeamsPage.vue
      overview: 'Visão Geral',
      assignment: 'Atribuição',
      //DocumentsPage.vue:
      totalDocuments: 'Total de Documentos',
      totalStorage: 'Armazenamento Total',
      documentsByTeamAndUser: 'Documentos por Equipe e Usuário',
      documentRepository: 'Repositório de Documentos',
      latestDocuments: 'Documentos Recentes',
      name: 'Nome',
      type: 'Tipo',
      size: 'Tamanho',
      date: 'Data',
      folder: 'Pasta',
      uploadedBy: 'Enviado Por',
      uploadedDate: 'Data de Envio',
      root: 'Raiz',
      unknownFolder: 'Pasta Desconhecida',
      unknownTeam: 'Equipe Desconhecida',
      unknownUser: 'Usuário Desconhecido',
      //charts
      itemBreakdown: "Detalhamento de Itens",
      controllerBreakdown: "Detalhamento de Controladores",
      documentUploads: "Uploads de Documentos ao Longo do Tempo",
      count: "Quantidade",
      documentTypes: "Tipos de Documentos",
      drawingBreakdown: "Detalhamento de Desenhos",
      activityByItem: "Atividade por Item",
      activityByLocation: "Atividade por Localização",
      burnup: {
        title: "Burnup",
        tooltip: "Este gráfico mostra o histórico do status acumulado ao longo do tempo do seu projeto.",
        day: "Dia",
        week: "Semana",
        month: "Mês"
      },
      velocityOverTime: "Velocidade ao Longo do Tempo",
      velocityTooltip: "Este gráfico mostra a atividade de mudança de status do seu projeto",
      day: "Dia",
      week: "Semana",
      month: "Mês",
      activityByTeam: "Atividade por Equipe",
      teamAndUserBreakdown: "Detalhamento por Equipe e Usuário",
      settings: {
        title: "Configurações",
        url: "URL",
        username: "Nome de Usuário",
        password: "Senha",
        selectProject: "Selecionar Projeto",
        close: "Fechar",
        submit: "Enviar",
        logout: "Sair"
      },
      welcomeMessage: "Bem-vindo ao {projectName}",
      loadDashboard: "Carregar Dashboard",
      devModeActivated: "Modo de desenvolvedor ativado",
      copyQueryStringTitle: "Copiar string de consulta",
      manualCopyInstruction: "Selecione o texto acima e copie-o manualmente (Ctrl/Cmd+C)",
      copy: "Copiar",
      copyFailed: "Falha ao copiar",
      search: 'Pesquisar',
      downloadPDF: 'Baixar PDF',
      downloadWord: 'Baixar Word',
      downloadExcel: 'Baixar Excel',
      downloadCSV: 'Baixar CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Relatório Resumido",
      subcategory: "Subcategoria",
      reportGenerated: "Relatório gerado",
      byCategory: "Por Categoria",
      byDrawingLocation: "Por Desenho / Localização",
      byDrawingAssignee: "Por Desenho / Responsável",
      byController: "Por Controlador",
      generateReport: 'Gerar relatório',
      downloadReport: 'Baixar relatório',
      grid: 'Grade',
      numeric: 'Numérico',
      selectReportType: 'Selecionar tipo de relatório',
      selectFileFormat: 'Selecionar formato de arquivo',
      selectPageSize: 'Selecionar tamanho da página',
      id: 'ID',
      item: 'Item',
      assignedTo: 'Atribuído Para',
      location: 'Localização',
      createdBy: 'Criado Por',
      updatedDate: 'Data de Atualização',
      status: 'Status',
      itemsGrid: 'Grade de Itens',
      noData: 'Sem dados disponíveis',
      itemsPerPage: 'Itens por página',
      subItem: 'Sub-Item',
      searchTeams: "Pesquisar equipes",
      assign: "Atribuir ({count})",
      tooltips: {
        selectUnassigned: "Selecionar Usuários Não Atribuídos",
        selectAll: "Selecionar Todos",
        deselectAll: "Desmarcar Todos",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Atribuído Para",
        updatedDate: "Data de Atualização",
        status: "Status",
      },
      cards: {
        unassigned: "Não Atribuído",
        userUnassigned: "Usuário Não Atribuído",
        draft: "Rascunho",
        open: "Aberto",
        closed: "Fechado",
      },
      assignedToYou: "Atribuído a Você",
      assignedToYourTeams: "Atribuído à(s) sua(s) Equipe(s)",
      controlledByYourTeams: "Controlado pela(s) sua(s) Equipe(s)",
      totalItems: "Total de Itens",
      totalOpenItems: "Total de Itens Abertos",
      totalOpenItemsTooltip: "O modo Total de Itens Abertos inclui apenas itens que estão em status aberto.",
      totalSubItems: "Total de Sub-Itens",
      totalSubItemsTooltip: "Total de Sub-Itens inclui templates com múltiplos formulários.",
      category: "Categoria",
      drawingSets: "Conjuntos de Desenhos",
      others: "Outros",
      teamDistribution: "Distribuição por Equipe",
      totalCount: "Contagem Total",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart", //nome do arquivo
      rdriveVelocityChart: "rdrive-velocity-chart", //nome do arquivo
      teamProfile: "Perfil da Equipe",
      unAssigned: "Não Atribuído",
      createdByYou: "Criado por Você",
      createdByYourTeams: "Criado pela(s) sua(s) Equipe(s)",
      loadingData: "Carregando",
      loadingActivity: "Carregando Atividade",
      noActivityWarning: "Não há atividade durante o período selecionado.",
      cancel: "Cancelar",
      today: "Atualizado hoje",
      dayAgo: "Atualizado há {daysSince} dia",
      daysAgo: "Atualizado há {daysSince} dias"
    },
    th: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "ตัวเลือกตัวกรอง",
        issueStatuses: "สถานะปัญหา",
        noAvailableStatus: "ไม่มีสถานะที่ใช้งานได้",
        selectAll: "เลือกทั้งหมด",
        deselectAll: "ยกเลิกการเลือกทั้งหมด",
        close: "ปิด",
        itemTypes: "ประเภทรายการ",
        issues: "ปัญหา",
        processes: "กระบวนการ",
        statuses: "สถานะ",
        globalFilters: "ตัวกรองส่วนกลาง",
      },
      //App.vue
      project: "โครงการ",
      teams: "ทีม",
      drawings: "แบบแปลน",
      documents: "เอกสาร",
      controllers: "ผู้ควบคุม",
      activity: "กิจกรรม",
      tasks: "งาน",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "S-Curve ความคืบหน้า — แผนเทียบกับจริง",
        leadTeam: "ทีมผู้รับผิดชอบ",
        task: "งาน",
        planned: "ตามแผน",
        actual: "จริง",
        today: "วันนี้",
        variance: "ส่วนต่าง",
        manDays: "คน-วัน",
        filtered: "กรองแล้ว",
        noData: "ไม่มีข้อมูลแผนงาน",
        liteChip: "PM lite",
        liteTooltip: "แผนงานนี้ไม่มีวันที่ตามแผน จึงไม่มีเส้นโค้งตามแผน แต่ละงานนับเป็นงาน 1 วัน",
        tasksUnit: "งาน",
        noProgress: "ยังไม่มีการบันทึกความคืบหน้า",
        liteTitle: "S-Curve ความคืบหน้า — จริง",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "ความคืบหน้าของงาน",
        syncChip: "PM Sync · แผนงานมีวันที่",
        liteChip: "PM Lite · ไม่มีวันที่",
        live: "สด",
        overall: "ภาพรวม",
        plannedFinish: "กำหนดเสร็จตามแผน",
        daysLeft: "จำนวนวันที่เหลือ",
        overrun: "เกินกำหนด {n} วัน",
        currentTasks: "งานปัจจุบัน",
        oneBucket: "แต่ละงานอยู่ในหมวดเดียวเท่านั้น",
        total: "รวม",
        needingWork: "งานที่ต้องดำเนินการวันนี้",
        canMove: "งานที่สามารถดำเนินต่อได้วันนี้",
        yourTeams: "{teams} · ทีมของคุณ",
        noTeam: "คุณไม่ได้อยู่ในทีมใด จึงไม่แสดงงาน",
        adminScope: "ทุกทีม · ผู้ดูแลระบบ",
        clearFilters: "ล้างตัวกรอง",
        noMatch: "ไม่มีงานที่ตรงกับการเลือกปัจจุบัน",
        completedThisWeek: "เสร็จสัปดาห์นี้",
        vsLastWeek: "{n} เทียบกับสัปดาห์ก่อน",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "งานทั้งหมด",
        open: "เปิดอยู่ {n} งาน",
        upcoming: "กำลังจะเริ่ม",
        upcomingHint: "วันเริ่มต้นหลังจากวันนี้",
        onSchedule: "ตามแผน",
        onScheduleHint: "เริ่มแล้ว · ความคืบหน้าเท่ากับหรือสูงกว่าแผน",
        behindSchedule: "ล่าช้ากว่าแผน",
        behindScheduleHint: "เริ่มแล้ว · ความคืบหน้าต่ำกว่าแผน",
        overdue: "เลยกำหนดเริ่ม",
        overdueHint: "ควรเริ่มแล้ว",
        overdueUpTo: "สูงสุด {n} วันที่ผ่านมา",
        delayed: "ล่าช้า",
        delayedHint: "เลยกำหนดเริ่ม + ล่าช้ากว่าแผน",
        completed: "เสร็จสิ้น",
        completedHint: "{pct}% ของงาน",
        notStarted: "ยังไม่เริ่ม",
        notStartedHint: "ไม่มีการบันทึกความคืบหน้า",
        inProgress: "กำลังดำเนินการ",
        inProgressHint: "มีการบันทึกความคืบหน้า ยังไม่เสร็จ",
        updatedThisWeek: "อัปเดตสัปดาห์นี้",
        stalled: "หยุดชะงัก",
        stalledHint: "ไม่มีการอัปเดต 7 วันขึ้นไป",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "ปริมาณงาน",
        doneSuffix: "เสร็จแล้ว · {span}ที่ผ่านมา",
        dueSuffix: "ครบกำหนด · {span}ข้างหน้า",
        spanDays: "{n} วัน",
        spanWeeks: "{n} สัปดาห์",
        weekBtn: "{n}สป.",
        wkPast: "สป. -{n}",
        wkNext: "สป. +{n}",
        verdictAbove: "งานที่ครบกำหนดสูงกว่าอัตราการทำเสร็จล่าสุด {pct}% — โปรดตรวจสอบกำลังการผลิต",
        verdictBelow: "งานที่ครบกำหนดต่ำกว่าอัตราการทำเสร็จล่าสุด — มีกำลังเหลือสำหรับดึงงานมาทำก่อน",
        verdictMatch: "งานที่ครบกำหนดสอดคล้องกับอัตราการทำเสร็จล่าสุด",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "กิจกรรมล่าสุด",
        task: "งาน",
        updated: "อัปเดต",
        progress: "ความคืบหน้า",
        dates: "วันที่",
        today: "วันนี้",
        yesterday: "เมื่อวาน",
        daysAgo: "{n} วันที่แล้ว",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "ทีมอื่นกำลังรอเรา",
        sub: "งานที่ยังไม่เสร็จของเราซึ่งทีมอื่นต้องพึ่งพา",
        subAll: "งานที่ยังไม่เสร็จซึ่งงานอื่นต้องพึ่งพา",
        empty: "ไม่มีทีมอื่นกำลังรอเรา",
        noData: "ยังไม่มีการบันทึกงานที่ต้องทำก่อนในงานของโครงการนี้",
        waiting: "{n} รอ",
        due: "กำหนด {date}",
        done: "เสร็จ {pct}%",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "รายละเอียดงาน",
        taskTitle: "ชื่องาน",
        taskViewer: "ตัวดูงาน",
        planViewer: "ตัวดูแบบแปลน",
        hierarchyPath: "เส้นทางลำดับชั้น",
        location: "ตำแหน่ง",
        status: "สถานะงาน",
        actualProgress: "ความคืบหน้าจริง",
        plannedProgress: "ความคืบหน้าตามแผน",
        plannedStart: "เริ่มตามแผน",
        actualStart: "เริ่มจริง",
        plannedEnd: "สิ้นสุดตามแผน",
        completion: "วันที่เสร็จ",
        overdueDays: "เกินกำหนด (วัน)",
        cycleDays: "รอบเวลา (วัน)",
        download: "ดาวน์โหลด CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "ความเร็ว",
        progressPerWeek: "ความคืบหน้าต่อสัปดาห์",
        tasksPerWeek: "งานที่เสร็จต่อสัปดาห์",
        toFinish: "จนเสร็จที่ความเร็วนี้",
        weeksShort: "~{n} สัปดาห์",
        avg: "เฉลี่ย",
        verdictUp: "ความเร็วสูงขึ้นเทียบกับ {n} สัปดาห์ก่อน",
        verdictDown: "ความเร็วลดลงเทียบกับ {n} สัปดาห์ก่อน",
        verdictSteady: "ความเร็วคงที่เทียบกับ {n} สัปดาห์ก่อน",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "ความคืบหน้าตามลำดับชั้นชุดแบบ",
        noData: "ไม่มีงานในขอบเขตที่เชื่อมกับแบบ",
        tasks: "{n} งาน",
        noDrawingSet: "ไม่มีชุดแบบ",
        expandAll: "ขยายทั้งหมด",
        collapseAll: "ยุบทั้งหมด",
      },
      switchTheme: "เปลี่ยนเป็นธีม{theme}",
      //ProjectPage.vue
      projectSummary: 'สรุปโครงการ',
      //TeamsPage.vue
      overview: 'ภาพรวม',
      assignment: 'การมอบหมาย',
      //DocumentsPage.vue:
      totalDocuments: 'จำนวนเอกสารทั้งหมด',
      totalStorage: 'พื้นที่จัดเก็บทั้งหมด',
      documentsByTeamAndUser: 'เอกสารแยกตามทีมและผู้ใช้',
      documentRepository: 'คลังเอกสาร',
      latestDocuments: 'เอกสารล่าสุด',
      name: 'ชื่อ',
      type: 'ประเภท',
      size: 'ขนาด',
      date: 'วันที่',
      folder: 'โฟลเดอร์',
      uploadedBy: 'อัพโหลดโดย',
      uploadedDate: 'วันที่อัพโหลด',
      root: 'รูท',
      unknownFolder: 'โฟลเดอร์ไม่ทราบชื่อ',
      unknownTeam: 'ทีมไม่ทราบชื่อ',
      unknownUser: 'ผู้ใช้ไม่ทราบชื่อ',
      //charts
      itemBreakdown: "การแจกแจงรายการ",
      controllerBreakdown: "การแจกแจงผู้ควบคุม",
      documentUploads: "การอัพโหลดเอกสารตามเวลา",
      count: "จำนวน",
      documentTypes: "ประเภทเอกสาร",
      drawingBreakdown: "การแจกแจงแบบแปลน",
      activityByItem: "กิจกรรมตามรายการ",
      activityByLocation: "กิจกรรมตามสถานที่",
      burnup: {
        title: "เบิร์นดาวน์",
        tooltip: "แผนภูมินี้แสดงสถานะสะสมตามประวัติของโครงการของคุณ",
        day: "วัน",
        week: "สัปดาห์",
        month: "เดือน"
      },
      velocityOverTime: "ความเร็วตามเวลา",
      velocityTooltip: "แผนภูมินี้แสดงการเปลี่ยนแปลงสถานะสำหรับโครงการของคุณ",
      day: "วัน",
      week: "สัปดาห์",
      month: "เดือน",
      activityByTeam: "กิจกรรมตามทีม",
      teamAndUserBreakdown: "การแจกแจงทีมและผู้ใช้",
      settings: {
        title: "การตั้งค่า",
        url: "URL",
        username: "ชื่อผู้ใช้",
        password: "รหัสผ่าน",
        selectProject: "เลือกโครงการ",
        close: "ปิด",
        submit: "ส่ง",
        logout: "ออกจากระบบ"
      },
      welcomeMessage: "ยินดีต้อนรับสู่ {projectName}",
      loadDashboard: "โหลดแดชบอร์ด",
      devModeActivated: "เปิดใช้งานโหมดนักพัฒนา",
      copyQueryStringTitle: "คัดลอกสตริงข้อความค้นหา",
      manualCopyInstruction: "เลือกข้อความด้านบนแล้วคัดลอกด้วยตนเอง (Ctrl/Cmd+C)",
      copy: "คัดลอก",
      copyFailed: "คัดลอกไม่สำเร็จ",
      search: 'ค้นหา',
      downloadPDF: 'ดาวน์โหลด PDF',
      downloadWord: 'ดาวน์โหลด Word',
      downloadExcel: 'ดาวน์โหลด Excel',
      downloadCSV: 'ดาวน์โหลด CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "รายงานสรุป",
      summaryReport: "รายงานสรุป",
      subcategory: "หมวดหมู่ย่อย",
      generateReport: "สร้างรายงาน",
      downloadReport: "ดาวน์โหลดรายงาน",
      reportGenerated: "สร้างรายงานแล้ว",
      byCategory: "ตามหมวดหมู่",
      byDrawingLocation: "ตามสถานที่แบบแปลน",
      byDrawingAssignee: "ตามผู้รับมอบหมายแบบแปลน",
      byController: "ตามผู้ควบคุม",
      grid: "ตาราง",
      numeric: "ตัวเลข",
      selectReportType: "เลือกประเภทรายงาน",
      selectFileFormat: "เลือกรูปแบบไฟล์",
      selectPageSize: "เลือกขนาดหน้า",
      id: 'รหัส',
      item: 'รายการ',
      assignedTo: 'มอบหมายให้',
      location: 'สถานที่',
      createdBy: 'สร้างโดย',
      updatedDate: 'วันที่อัปเดต',
      status: 'สถานะ',
      itemsGrid: 'ตารางรายการ',
      noData: 'ไม่มีข้อมูล',
      itemsPerPage: 'รายการต่อหน้า',
      subItem: 'รายการย่อย',
      searchTeams: "ค้นหาทีม",
      assign: "มอบหมาย ({count})",
      tooltips: {
        selectUnassigned: "เลือกผู้ใช้ที่ยังไม่ได้รับมอบหมาย",
        selectAll: "เลือกทั้งหมด",
        deselectAll: "ยกเลิกการเลือกทั้งหมด",
      },
      headers: {
        subItem: "รายการย่อย",
        assignedTo: "มอบหมายให้",
        updatedDate: "วันที่อัปเดต",
        status: "สถานะ",
      },
      cards: {
        unassigned: "ยังไม่ได้มอบหมาย",
        userUnassigned: "ผู้ใช้ที่ยังไม่ได้รับมอบหมาย",
        draft: "ร่าง",
        open: "เปิด",
        closed: "ปิด",
      },
      assignedToYou: "มอบหมายให้คุณ",
      assignedToYourTeams: "มอบหมายให้ทีมของคุณ",
      controlledByYourTeams: "ควบคุมโดยทีมของคุณ",
      totalItems: "รายการทั้งหมด",
      totalOpenItems: "รายการที่เปิดทั้งหมด",
      totalOpenItemsTooltip: "โหมดรายการที่เปิดทั้งหมดจะรวมเฉพาะรายการที่มีสถานะเปิดเท่านั้น",
      totalSubItems: "รายการย่อยทั้งหมด",
      totalSubItemsTooltip: "รายการย่อยทั้งหมดรวมถึงเทมเพลตที่มีแบบฟอร์มหลายแบบ",
      category: "หมวดหมู่",
      drawingSets: "ชุดแบบแปลน",
      others: "อื่นๆ",
      teamDistribution: "การกระจายของทีม",
      totalCount: "จำนวนรวม",
      total: "รวม",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "โปรไฟล์ทีม",
      unAssigned: "ยังไม่ได้มอบหมาย",
      createdByYou: "สร้างโดยคุณ",
      createdByYourTeams: "สร้างโดยทีมของคุณ",
      loadingData: "กำลังโหลด",
      loadingActivity: "กำลังโหลดกิจกรรม",
      noActivityWarning: "ไม่มีกิจกรรมในช่วงวันที่ที่เลือก",
      cancel: "ยกเลิก",
      today: "อัปเดตวันนี้",
      dayAgo: "อัปเดต {daysSince} วันที่แล้ว",
      daysAgo: "อัปเดต {daysSince} วันที่แล้ว"
    },
    de: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Filteroptionen",
        issueStatuses: "Problemstatus",
        noAvailableStatus: "Kein Status Verfügbar",
        selectAll: "Alle Auswählen",
        deselectAll: "Alle Abwählen",
        close: "Schließen",
        itemTypes: "Elementtypen",
        issues: "Probleme",
        processes: "Prozesse",
        statuses: "Status",
        globalFilters: "Globale Filter",
      },
      //App.vue
      project: "Projekt",
      teams: "Teams",
      drawings: "Zeichnungen",
      documents: "Dokumente",
      controllers: "Controller",
      activity: "Aktivität",
      tasks: "Aufgaben",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Fortschritts-S-Kurve — Geplant vs. Ist",
        leadTeam: "Leitendes Team",
        task: "Aufgabe",
        planned: "Geplant",
        actual: "Ist",
        today: "Heute",
        variance: "Abweichung",
        manDays: "Personentage",
        filtered: "gefiltert",
        noData: "Keine Terminplandaten verfügbar",
        liteChip: "PM lite",
        liteTooltip: "Dieser Terminplan hat keine geplanten Termine, daher gibt es keine Plankurve. Jede Aufgabe zählt als 1 Arbeitstag.",
        tasksUnit: "Aufgaben",
        noProgress: "Es wurde noch kein Fortschritt erfasst",
        liteTitle: "Fortschritts-S-Kurve — Ist",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Arbeitsfortschritt",
        syncChip: "PM Sync · terminierter Zeitplan",
        liteChip: "PM Lite · ohne Termine",
        live: "Live",
        overall: "Gesamt",
        plannedFinish: "Geplantes Ende",
        daysLeft: "Verbleibende Tage",
        overrun: "Überschreitung {n} T.",
        currentTasks: "Aktuelle Aufgaben",
        oneBucket: "Jede Aufgabe gehört genau einer Kategorie an",
        total: "Gesamt",
        needingWork: "Aufgaben, die heute Arbeit benötigen",
        canMove: "Aufgaben, die heute vorankommen können",
        yourTeams: "{teams} · Ihre Teams",
        noTeam: "Sie gehören keinem Team an, daher werden keine Aufgaben angezeigt",
        adminScope: "Alle Teams · Administrator",
        clearFilters: "Filter zurücksetzen",
        noMatch: "Keine Aufgaben entsprechen der aktuellen Auswahl",
        completedThisWeek: "Diese Woche erledigt",
        vsLastWeek: "{n} ggü. Vorwoche",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Aufgaben gesamt",
        open: "{n} offen",
        upcoming: "Bevorstehend",
        upcomingHint: "Starttermin nach heute",
        onSchedule: "Im Plan",
        onScheduleHint: "Begonnen · Fortschritt im oder über Plan",
        behindSchedule: "Hinter Plan",
        behindScheduleHint: "Begonnen · Fortschritt unter Plan",
        overdue: "Überfällig",
        overdueHint: "Hätte beginnen sollen",
        overdueUpTo: "vor bis zu {n} Tagen",
        delayed: "Verzögert",
        delayedHint: "Überfällig + hinter Plan",
        completed: "Abgeschlossen",
        completedHint: "{pct}% der Aufgaben",
        notStarted: "Nicht begonnen",
        notStartedHint: "Kein Fortschritt erfasst",
        inProgress: "In Bearbeitung",
        inProgressHint: "Fortschritt erfasst, noch nicht abgeschlossen",
        updatedThisWeek: "Diese Woche aktualisiert",
        stalled: "Ins Stocken geraten",
        stalledHint: "Seit 7+ Tagen kein Update",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Arbeitslast",
        doneSuffix: "erledigt · letzte {span}",
        dueSuffix: "fällig · nächste {span}",
        spanDays: "{n} Tage",
        spanWeeks: "{n} Wochen",
        weekBtn: "{n}W",
        wkPast: "KW -{n}",
        wkNext: "KW +{n}",
        verdictAbove: "Die fällige Arbeit liegt {pct}% über der jüngsten Erledigungsrate — Kapazität prüfen",
        verdictBelow: "Die fällige Arbeit liegt unter der jüngsten Erledigungsrate — Kapazität, um Arbeit vorzuziehen",
        verdictMatch: "Die fällige Arbeit entspricht der jüngsten Erledigungsrate",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Letzte Aktivität",
        task: "Aufgabe",
        updated: "Aktualisiert",
        progress: "Fortschritt",
        dates: "Termine",
        today: "Heute",
        yesterday: "Gestern",
        daysAgo: "vor {n} Tagen",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Andere warten auf uns",
        sub: "Unsere unerledigten Aufgaben, von denen andere Teams abhängen",
        subAll: "Unerledigte Aufgaben, von denen andere Aufgaben abhängen",
        empty: "Kein anderes Team wartet auf uns.",
        noData: "Für die Aufgaben dieses Projekts sind noch keine Voraussetzungen erfasst.",
        waiting: "{n} wartend",
        due: "fällig {date}",
        done: "{pct}% erledigt",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Aufgabendetails",
        taskTitle: "Aufgabentitel",
        taskViewer: "Aufgabenansicht",
        planViewer: "Planansicht",
        hierarchyPath: "Hierarchiepfad",
        location: "Standort",
        status: "Status",
        actualProgress: "Ist-Fortschritt",
        plannedProgress: "Plan-Fortschritt",
        plannedStart: "Geplanter Start",
        actualStart: "Tatsächlicher Start",
        plannedEnd: "Geplantes Ende",
        completion: "Abschluss",
        overdueDays: "Überfällig (Tage)",
        cycleDays: "Durchlaufzeit (Tage)",
        download: "CSV herunterladen",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Tempo",
        progressPerWeek: "Fortschritt pro Woche",
        tasksPerWeek: "erledigte Aufgaben pro Woche",
        toFinish: "bis zum Abschluss bei diesem Tempo",
        weeksShort: "~{n} Wo.",
        avg: "Ø",
        verdictUp: "Das Tempo liegt über den vorherigen {n} Wochen",
        verdictDown: "Das Tempo liegt unter den vorherigen {n} Wochen",
        verdictSteady: "Das Tempo ist gleich wie in den vorherigen {n} Wochen",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Fortschritt nach Zeichnungssatz-Hierarchie",
        noData: "Keine Aufgabe im Umfang ist mit einer Zeichnung verknüpft",
        tasks: "{n} Aufgaben",
        noDrawingSet: "Kein Zeichnungssatz",
        expandAll: "Alle ausklappen",
        collapseAll: "Alle einklappen",
      },
      switchTheme: "Zum {theme}-Design wechseln",
      //ProjectPage.vue
      projectSummary: 'Projektübersicht',
      //TeamsPage.vue
      overview: 'Überblick',
      assignment: 'Zuweisung',
      //DocumentsPage.vue:
      totalDocuments: 'Gesamtdokumente',
      totalStorage: 'Gesamtspeicher',
      documentsByTeamAndUser: 'Dokumente nach Team und Benutzer',
      documentRepository: 'Dokumentenablage',
      latestDocuments: 'Neueste Dokumente',
      name: 'Name',
      type: 'Typ',
      size: 'Größe',
      date: 'Datum',
      folder: 'Ordner',
      uploadedBy: 'Hochgeladen von',
      uploadedDate: 'Hochladedatum',
      root: 'Stammverzeichnis',
      unknownFolder: 'Unbekannter Ordner',
      unknownTeam: 'Unbekanntes Team',
      unknownUser: 'Unbekannter Benutzer',
      //charts
      itemBreakdown: "Elementaufschlüsselung",
      controllerBreakdown: "Controller-Aufschlüsselung",
      documentUploads: "Dokumenten-Uploads im Zeitverlauf",
      count: "Anzahl",
      documentTypes: "Dokumententypen",
      drawingBreakdown: "Zeichnungsaufschlüsselung",
      activityByItem: "Aktivität nach Element",
      activityByLocation: "Aktivität nach Standort",
      burnup: {
        title: "Burnup",
        tooltip: "Dieses Diagramm zeigt den historischen kumulativen Status Ihres Projekts im Zeitverlauf.",
        day: "Tag",
        week: "Woche",
        month: "Monat"
      },
      velocityOverTime: "Geschwindigkeit im Zeitverlauf",
      velocityTooltip: "Dieses Diagramm zeigt die Statusänderungsaktivität für Ihr Projekt",
      day: "Tag",
      week: "Woche",
      month: "Monat",
      activityByTeam: "Aktivität nach Team",
      teamAndUserBreakdown: "Team- und Benutzeraufschlüsselung",
      settings: {
        title: "Einstellungen",
        url: "URL",
        username: "Benutzername",
        password: "Passwort",
        selectProject: "Projekt auswählen",
        close: "Schließen",
        submit: "Absenden",
        logout: "Abmelden"
      },
      welcomeMessage: "Willkommen bei {projectName}",
      loadDashboard: "Dashboard laden",
      devModeActivated: "Entwicklermodus aktiviert",
      copyQueryStringTitle: "Abfragezeichenfolge kopieren",
      manualCopyInstruction: "Wählen Sie den obigen Text aus und kopieren Sie ihn manuell (Strg/Cmd+C)",
      copy: "Kopieren",
      copyFailed: "Kopieren fehlgeschlagen",
      search: 'Suchen',
      downloadPDF: 'PDF herunterladen',
      downloadWord: 'Word herunterladen',
      downloadExcel: 'Excel herunterladen',
      downloadCSV: 'CSV herunterladen',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "Zusammenfassungsbericht",
      summaryReport: "Zusammenfassungsbericht",
      subcategory: "Unterkategorie",
      generateReport: "Bericht erstellen",
      downloadReport: "Bericht herunterladen",
      reportGenerated: "Bericht erstellt",
      byCategory: "Nach Kategorie",
      byDrawingLocation: "Nach Zeichnungsstandort",
      byDrawingAssignee: "Nach Zeichnungszuständigem",
      byController: "Nach Controller",
      grid: "Raster",
      numeric: "Numerisch",
      selectReportType: "Berichtstyp auswählen",
      selectFileFormat: "Dateiformat auswählen",
      selectPageSize: "Seitengröße auswählen",
      id: 'ID',
      item: 'Element',
      assignedTo: 'Zugewiesen an',
      location: 'Standort',
      createdBy: 'Erstellt von',
      updatedDate: 'Aktualisierungsdatum',
      status: 'Status',
      itemsGrid: 'Elementeraster',
      noData: 'Keine Daten verfügbar',
      itemsPerPage: 'Elemente pro Seite',
      subItem: 'Unterelement',
      searchTeams: "Teams suchen",
      assign: "Zuweisen ({count})",
      tooltips: {
        selectUnassigned: "Nicht zugewiesene Benutzer auswählen",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
      },
      headers: {
        subItem: "Unterelement",
        assignedTo: "Zugewiesen an",
        updatedDate: "Aktualisierungsdatum",
        status: "Status",
      },
      cards: {
        unassigned: "Nicht zugewiesen",
        userUnassigned: "Benutzer nicht zugewiesen",
        draft: "Entwurf",
        open: "Offen",
        closed: "Geschlossen",
      },
      assignedToYou: "Ihnen zugewiesen",
      assignedToYourTeams: "Ihrem Team/Ihren Teams zugewiesen",
      controlledByYourTeams: "Von Ihrem Team/Ihren Teams kontrolliert",
      totalItems: "Gesamtelemente",
      totalOpenItems: "Offene Elemente gesamt",
      totalOpenItemsTooltip: "Der Modus 'Offene Elemente gesamt' enthält nur Elemente mit offenem Status.",
      totalSubItems: "Unterelemente gesamt",
      totalSubItemsTooltip: "Unterelemente gesamt enthält Vorlagen mit mehreren Formularen.",
      category: "Kategorie",
      drawingSets: "Zeichnungssätze",
      others: "Sonstige",
      teamDistribution: "Teamverteilung",
      totalCount: "Gesamtanzahl",
      total: "Gesamt",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Teamprofil",
      unAssigned: "Nicht zugewiesen",
      createdByYou: "Von Ihnen erstellt",
      createdByYourTeams: "Von Ihrem Team/Ihren Teams erstellt",
      loadingData: "Wird geladen",
      loadingActivity: "Aktivität wird geladen",
      noActivityWarning: "Es gibt keine Aktivität im ausgewählten Zeitraum.",
      cancel: "Abbrechen",
      today: "Heute aktualisiert",
      dayAgo: "Vor {daysSince} Tag aktualisiert",
      daysAgo: "Vor {daysSince} Tagen aktualisiert"
    },
    pl: {
      //StatusFilterFab.vue
      filterDialog: {
        title: "Opcje Filtrowania",
        issueStatuses: "Statusy Problemów",
        noAvailableStatus: "Brak Dostępnego Statusu",
        selectAll: "Wybierz Wszystko",
        deselectAll: "Odznacz Wszystko",
        close: "Zamknij",
        itemTypes: "Typy Elementów",
        issues: "Problemy",
        processes: "Procesy",
        statuses: "Statusy",
        globalFilters: "Filtry globalne",
      },
      //App.vue
      project: "Projekt",
      teams: "Zespoły",
      drawings: "Rysunki",
      documents: "Dokumenty",
      controllers: "Kontrolerzy",
      activity: "Aktywność",
      tasks: "Zadania",
      //TaskSCurveLineChart.vue
      taskSCurve: {
        title: "Krzywa S postępu — Plan vs Rzeczywistość",
        leadTeam: "Zespół prowadzący",
        task: "Zadanie",
        planned: "Plan",
        actual: "Rzeczywistość",
        today: "Dzisiaj",
        variance: "Odchylenie",
        manDays: "osobodni",
        filtered: "przefiltrowane",
        noData: "Brak danych harmonogramu",
        liteChip: "PM lite",
        liteTooltip: "Ten harmonogram nie ma planowanych dat, więc nie ma krzywej planowanej. Każde zadanie liczy się jako 1 dzień pracy.",
        tasksUnit: "zadań",
        noProgress: "Nie zarejestrowano jeszcze postępu",
        liteTitle: "Krzywa S postępu — Rzeczywistość",
      },
      //TasksPage.vue · TaskOverallCard.vue · TaskCurrentTasksCard.vue
      taskOverview: {
        title: "Postęp prac",
        syncChip: "PM Sync · harmonogram z datami",
        liteChip: "PM Lite · bez dat",
        live: "Na żywo",
        overall: "Ogółem",
        plannedFinish: "Planowane zakończenie",
        daysLeft: "Pozostałe dni",
        overrun: "Przekroczenie o {n} dni",
        currentTasks: "Bieżące zadania",
        oneBucket: "Każde zadanie należy tylko do jednej kategorii",
        total: "Razem",
        needingWork: "zadania wymagające pracy dzisiaj",
        canMove: "zadania, które mogą dziś posunąć się naprzód",
        yourTeams: "{teams} · Twoje zespoły",
        noTeam: "Nie należysz do żadnego zespołu, więc nie są wyświetlane żadne zadania",
        adminScope: "Wszystkie zespoły · administrator",
        clearFilters: "Wyczyść filtry",
        noMatch: "Żadne zadanie nie pasuje do bieżącego wyboru",
        completedThisWeek: "Ukończone w tym tygodniu",
        vsLastWeek: "{n} vs poprzedni tydzień",
      },
      //TaskOverallCard.vue · TaskCurrentTasksCard.vue (status vocabulary)
      taskStatus: {
        totalTasks: "Wszystkie zadania",
        open: "{n} otwartych",
        upcoming: "Nadchodzące",
        upcomingHint: "Data rozpoczęcia po dzisiaj",
        onSchedule: "Zgodnie z planem",
        onScheduleHint: "Rozpoczęte · postęp na poziomie planu lub wyższy",
        behindSchedule: "Za planem",
        behindScheduleHint: "Rozpoczęte · postęp poniżej planu",
        overdue: "Zaległe",
        overdueHint: "Powinno się rozpocząć",
        overdueUpTo: "do {n} dni temu",
        delayed: "Opóźnione",
        delayedHint: "Zaległe + za planem",
        completed: "Ukończone",
        completedHint: "{pct}% zadań",
        notStarted: "Nierozpoczęte",
        notStartedHint: "Brak zarejestrowanego postępu",
        inProgress: "W toku",
        inProgressHint: "Postęp zarejestrowany, jeszcze nieukończone",
        updatedThisWeek: "Zaktualizowane w tym tygodniu",
        stalled: "Zatrzymane",
        stalledHint: "Brak aktualizacji od 7+ dni",
      },
      //TaskWorkloadChart.vue
      taskWorkload: {
        title: "Obciążenie pracą",
        doneSuffix: "ukończone · ostatnie {span}",
        dueSuffix: "z terminem · następne {span}",
        spanDays: "{n} dni",
        spanWeeks: "{n} tyg.",
        weekBtn: "{n}t",
        wkPast: "Tydz. -{n}",
        wkNext: "Tydz. +{n}",
        verdictAbove: "Praca z terminem przekracza o {pct}% ostatnie tempo ukończeń — sprawdź przepustowość",
        verdictBelow: "Praca z terminem jest poniżej ostatniego tempa ukończeń — jest zapas na przyspieszenie pracy",
        verdictMatch: "Praca z terminem odpowiada ostatniemu tempu ukończeń",
      },
      //TaskRecentActivityCard.vue
      taskRecent: {
        title: "Ostatnia aktywność",
        task: "Zadanie",
        updated: "Zaktualizowano",
        progress: "Postęp",
        dates: "Daty",
        today: "Dziś",
        yesterday: "Wczoraj",
        daysAgo: "{n} dni temu",
      },
      //TaskWaitingOnUsCard.vue
      taskWaiting: {
        title: "Inni czekają na nas",
        sub: "Nasze nieukończone zadania, od których zależą inne zespoły",
        subAll: "Nieukończone zadania, od których zależą inne zadania",
        empty: "Żaden inny zespół na nas nie czeka.",
        noData: "W zadaniach tego projektu nie zapisano jeszcze żadnych zależności.",
        waiting: "{n} czeka",
        due: "termin {date}",
        done: "{pct}% wykonano",
      },
      //TaskDetailsGrid.vue
      taskDetails: {
        title: "Szczegóły zadań",
        taskTitle: "Tytuł zadania",
        taskViewer: "Podgląd zadania",
        planViewer: "Podgląd planu",
        hierarchyPath: "Ścieżka hierarchii",
        location: "Lokalizacja",
        status: "Status zadania",
        actualProgress: "Postęp rzeczywisty",
        plannedProgress: "Postęp planowany",
        plannedStart: "Planowany start",
        actualStart: "Rzeczywisty start",
        plannedEnd: "Planowany koniec",
        completion: "Ukończenie",
        overdueDays: "Opóźnienie (dni)",
        cycleDays: "Cykl (dni)",
        download: "Pobierz CSV",
      },
      //TaskPaceChart.vue
      taskPace: {
        title: "Tempo",
        progressPerWeek: "postęp tygodniowo",
        tasksPerWeek: "ukończone zadania tygodniowo",
        toFinish: "do zakończenia w tym tempie",
        weeksShort: "~{n} tyg.",
        avg: "śr.",
        verdictUp: "Tempo jest wyższe niż w poprzednich {n} tygodniach",
        verdictDown: "Tempo jest niższe niż w poprzednich {n} tygodniach",
        verdictSteady: "Tempo jest takie samo jak w poprzednich {n} tygodniach",
      },
      //TaskProgressByDrawingCard.vue
      taskDrawing: {
        title: "Postęp wg hierarchii zestawów rysunków",
        noData: "Żadne zadanie w zakresie nie jest powiązane z rysunkiem",
        tasks: "{n} zadań",
        noDrawingSet: "Brak zestawu rysunków",
        expandAll: "Rozwiń wszystko",
        collapseAll: "Zwiń wszystko",
      },
      switchTheme: "Przełącz na motyw {theme}",
      //ProjectPage.vue
      projectSummary: 'Podsumowanie projektu',
      //TeamsPage.vue
      overview: 'Przegląd',
      assignment: 'Przypisanie',
      //DocumentsPage.vue:
      totalDocuments: 'Łączna liczba dokumentów',
      totalStorage: 'Łączna przestrzeń',
      documentsByTeamAndUser: 'Dokumenty według zespołu i użytkownika',
      documentRepository: 'Repozytorium dokumentów',
      latestDocuments: 'Najnowsze dokumenty',
      name: 'Nazwa',
      type: 'Typ',
      size: 'Rozmiar',
      date: 'Data',
      folder: 'Folder',
      uploadedBy: 'Przesłane przez',
      uploadedDate: 'Data przesłania',
      root: 'Główny',
      unknownFolder: 'Nieznany folder',
      unknownTeam: 'Nieznany zespół',
      unknownUser: 'Nieznany użytkownik',
      //charts
      itemBreakdown: "Podział elementów",
      controllerBreakdown: "Podział kontrolerów",
      documentUploads: "Przesłane dokumenty w czasie",
      count: "Liczba",
      documentTypes: "Typy dokumentów",
      drawingBreakdown: "Podział rysunków",
      activityByItem: "Aktywność według elementu",
      activityByLocation: "Aktywność według lokalizacji",
      burnup: {
        title: "Wykres spalania",
        tooltip: "Ten wykres pokazuje historyczny skumulowany status projektu w czasie.",
        day: "Dzień",
        week: "Tydzień",
        month: "Miesiąc"
      },
      velocityOverTime: "Prędkość w czasie",
      velocityTooltip: "Ten wykres pokazuje zmiany statusu w twoim projekcie",
      day: "Dzień",
      week: "Tydzień",
      month: "Miesiąc",
      activityByTeam: "Aktywność według zespołu",
      teamAndUserBreakdown: "Podział zespołów i użytkowników",
      settings: {
        title: "Ustawienia",
        url: "URL",
        username: "Nazwa użytkownika",
        password: "Hasło",
        selectProject: "Wybierz projekt",
        close: "Zamknij",
        submit: "Zatwierdź",
        logout: "Wyloguj"
      },
      welcomeMessage: "Witaj w {projectName}",
      loadDashboard: "Wczytaj panel",
      devModeActivated: "Tryb deweloperski aktywowany",
      copyQueryStringTitle: "Skopiuj ciąg zapytania",
      manualCopyInstruction: "Zaznacz powyższy tekst i skopiuj go ręcznie (Ctrl/Cmd+C)",
      copy: "Kopiuj",
      copyFailed: "Kopiowanie nie powiodło się",
      search: 'Szukaj',
      downloadPDF: 'Pobierz PDF',
      downloadWord: 'Pobierz Word',
      downloadExcel: 'Pobierz Excel',
      downloadCSV: 'Pobierz CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "Raport podsumowujący",
      summaryReport: "Raport podsumowujący",
      subcategory: "Podkategoria",
      generateReport: "Generuj raport",
      downloadReport: "Pobierz raport",
      reportGenerated: "Raport wygenerowany",
      byCategory: "Według kategorii",
      byDrawingLocation: "Według lokalizacji rysunku",
      byDrawingAssignee: "Według przypisanego do rysunku",
      byController: "Według kontrolera",
      grid: "Siatka",
      numeric: "Numeryczny",
      selectReportType: "Wybierz typ raportu",
      selectFileFormat: "Wybierz format pliku",
      selectPageSize: "Wybierz rozmiar strony",
      id: 'ID',
      item: 'Element',
      assignedTo: 'Przypisane do',
      location: 'Lokalizacja',
      createdBy: 'Utworzone przez',
      updatedDate: 'Data aktualizacji',
      status: 'Status',
      itemsGrid: 'Siatka elementów',
      noData: 'Brak dostępnych danych',
      itemsPerPage: 'Elementów na stronę',
      subItem: 'Podelement',
      searchTeams: "Szukaj zespołów",
      assign: "Przypisz ({count})",
      tooltips: {
        selectUnassigned: "Wybierz nieprzypisanych użytkowników",
        selectAll: "Wybierz wszystko",
        deselectAll: "Odznacz wszystko",
      },
      headers: {
        subItem: "Podelement",
        assignedTo: "Przypisane do",
        updatedDate: "Data aktualizacji",
        status: "Status",
      },
      cards: {
        unassigned: "Nieprzypisane",
        userUnassigned: "Użytkownik nieprzypisany",
        draft: "Wersja robocza",
        open: "Otwarte",
        closed: "Zamknięte",
      },
      assignedToYou: "Przypisane do Ciebie",
      assignedToYourTeams: "Przypisane do Twoich zespołów",
      controlledByYourTeams: "Kontrolowane przez Twoje zespoły",
      totalItems: "Łączna liczba elementów",
      totalOpenItems: "Łączna liczba otwartych elementów",
      totalOpenItemsTooltip: "Tryb łącznej liczby otwartych elementów zawiera tylko elementy o statusie otwartym.",
      totalSubItems: "Łączna liczba podelementów",
      totalSubItemsTooltip: "Łączna liczba podelementów zawiera szablony z wieloma formularzami.",
      category: "Kategoria",
      drawingSets: "Zestawy rysunków",
      others: "Inne",
      teamDistribution: "Rozkład zespołów",
      totalCount: "Łączna liczba",
      total: "Suma",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Profil zespołu",
      unAssigned: "Nieprzypisane",
      createdByYou: "Utworzone przez Ciebie",
      createdByYourTeams: "Utworzone przez Twoje zespoły",
      loadingData: "Ładowanie",
      loadingActivity: "Ładowanie aktywności",
      noActivityWarning: "Brak aktywności w wybranym przedziale czasowym.",
      cancel: "Anuluj",
      today: "Zaktualizowano dzisiaj",
      dayAgo: "Zaktualizowano {daysSince} dzień temu",
      daysAgo: "Zaktualizowano {daysSince} dni temu"
    }
  };